// import React, { useRef, useEffect, useState, useMemo } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { Button, Spinner } from "react-bootstrap";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import { useLocation, useNavigate } from "react-router-dom";
// import offerLetterBackgroundImage from "../../Assets/Vetrina Offer Letter-1.png";
// // Removed offerLetterBackgroundImage2 as pagination handles background per page now
// import html2pdf from "html2pdf.js";
// import axios from "axios";
// import Swal from "sweetalert2";
// import VetrinaStamp from "../../Assets/VetrinaStamp.png";

// // =====================================================================
// // ===== MANUAL LAYOUT CONFIGURATION (From Modified Code) =============
// // =====================================================================
// const PAGE_WIDTH_PX = 595;
// const PAGE_HEIGHT_PX = 842;
// const HEADER_CONTENT_LEFT_PX = 68;
// const HEADER_CONTENT_RIGHT_MARGIN_PX = 60;
// const HEADER_CONTENT_TOP_PX = 83;
// const CONTENT_LEFT_PX = 68;
// const CONTENT_WIDTH_PX = 475;
// const CONTENT_TOP_PAGE_1_PX = 200; // Start content lower on page 1
// const CONTENT_TOP_SUBSEQUENT_PX = 110; // Start content higher on subsequent pages
// const CONTENT_BOTTOM_MARGIN_PX = 55; // Space before footer might start
// const FOOTER_TOP_PX = 640; // Where the footer block starts (relative to page top)
// const FOOTER_LEFT_PX = 68;
// const FOOTER_WIDTH_PX = 475;
// const STAMP_OFFSET_TOP_PX = -50; // Offset relative to FOOTER_TOP_PX (590px absolute)
// const STAMP_OFFSET_LEFT_PX = 72; // Offset relative to FOOTER_LEFT_PX (140px absolute)
// const STAMP_WIDTH_PX = 100;
// const STAMP_HEIGHT_PX = 100;
// const SIGNATURE_OFFSET_TOP_PX = -10; // Offset relative to FOOTER_TOP_PX (630px absolute)
// const SIGNATURE_OFFSET_LEFT_PX = 0; // Offset relative to FOOTER_LEFT_PX (68px absolute)
// const SIGNATURE_WIDTH_PX = 100;
// const SIGNATURE_HEIGHT_PX = 50;
// // =====================================================================
// // ===== DERIVED CALCULATIONS (From Modified Code) ====================
// // =====================================================================
// const MAX_CONTENT_FILL_HEIGHT_PAGE_1 = PAGE_HEIGHT_PX - CONTENT_TOP_PAGE_1_PX - CONTENT_BOTTOM_MARGIN_PX;
// const MAX_CONTENT_HEIGHT_SUBSEQUENT = FOOTER_TOP_PX - CONTENT_TOP_SUBSEQUENT_PX + 110; // Max content height on pages 2+ before hitting footer area
// // =====================================================================

// // --- Helper Functions ---
// const formatDate = (date) => { // Using robust version from modified code
//     if (!date) return "";
//     try {
//         if (typeof date === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
//             return date;
//         }
//         const d = new Date(date);
//         if (isNaN(d.getTime())) {
//             const isoDate = new Date(Date.parse(date));
//             if (isNaN(isoDate.getTime())) {
//                 console.warn("Invalid date:", date);
//                 return "Invalid Date";
//             }
//             const day = String(isoDate.getDate()).padStart(2, "0");
//             const month = String(isoDate.getMonth() + 1).padStart(2, "0");
//             const year = isoDate.getFullYear();
//             return `${day}/${month}/${year}`;
//         }
//         const day = String(d.getDate()).padStart(2, "0");
//         const month = String(d.getMonth() + 1).padStart(2, "0");
//         const year = d.getFullYear();
//         return `${day}/${month}/${year}`;
//     } catch (e) {
//         console.error("Date format error:", date, e);
//         return "Error Date";
//     }
// };

// const OfferLetter = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const formData = location.state || {};
//     const offerLetterRef = useRef(null);
//     const measureRef = useRef(null); // For custom content pagination measurement

//     const [renderedPagesData, setRenderedPagesData] = useState([]);
//     const [isCalculatingPages, setIsCalculatingPages] = useState(false);
//     const [isDataValid, setIsDataValid] = useState(false);

//     // Use memoized safeData for stability (From Modified Code)
//     const safeData = useMemo(() => ({
//         candidateName: formData.candidateName || "Candidate Name",
//         date: formatDate(formData.date),
//         address: formData.address || "[Address]",
//         pinCode: formData.pinCode || "[Pin Code]",
//         mobileNumber: formData.mobileNumber || "[Mobile Number]",
//         hrName: formData.hr?.name || "[HR Manager Name]",
//         hrTitle: "HR Manager", // Assuming constant title
//         position: formData.position || "[Position]", // Used by template
//         salary: formData.salary || "[N/A]",         // Used by template
//         reportingTo: formData.reporting_manager || "[Reporting Manager]", // Used by template
//         basedHQ: formData.headquarter || "[Base HQ]", // Used by template
//         customContent: formData.customContent || "",   // Used by custom
//         generationMethod: formData.generationMethod,
//         signaturePreviewUrl: formData.signaturePreviewUrl || null,
//         user_id: formData.user_id,
//     }), [formData]);

//     // --- Data Validation Effect (From Modified Code - More Robust) ---
//     useEffect(() => {
//         console.log("OfferLetter State:", formData);
//         let isDataMissing = false;
//         let missingFields = [];

//         // Basic checks (needed for both)
//         if (!safeData.candidateName || safeData.candidateName === "Candidate Name") { isDataMissing = true; missingFields.push('candidateName'); }
//         if (!safeData.date || safeData.date === "Invalid Date" || safeData.date === "Error Date") { isDataMissing = true; missingFields.push('date'); }
//         if (!safeData.hrName || safeData.hrName === "[HR Manager Name]") { isDataMissing = true; missingFields.push('hr'); }
//         // Signature is needed for footer
//         if (!safeData.signaturePreviewUrl) { isDataMissing = true; missingFields.push('signature'); }

//         // Template specific checks
//         if (safeData.generationMethod === 'template') {
//             const flds = ['position', 'salary', 'address', 'pinCode', 'mobileNumber', 'reportingTo', 'basedHQ']; // Add all template fields
//             flds.forEach(f => {
//                 const value = safeData[f];
//                 if (!value || (typeof value === 'string' && value.startsWith('[')) || value === "Candidate Name" || value === "[N/A]") { // Added more checks
//                     isDataMissing = true;
//                     if (!missingFields.includes(f)) missingFields.push(f);
//                 }
//             });
//         }
//         // Custom specific checks
//         else if (safeData.generationMethod === 'custom') {
//             if (!safeData.customContent) {
//                 isDataMissing = true;
//                 if (!missingFields.includes('customContent')) missingFields.push('customContent');
//             }
//              // Custom also needs address details for header
//             const headerFields = ['address', 'pinCode', 'mobileNumber'];
//             headerFields.forEach(f => {
//                 const value = safeData[f];
//                 if (!value || (typeof value === 'string' && value.startsWith('['))) {
//                      isDataMissing = true;
//                      if (!missingFields.includes(f)) missingFields.push(f);
//                 }
//             });
//         }
//         // Check if generationMethod itself is missing/invalid
//         else {
//             isDataMissing = true;
//             missingFields.push('generationMethod');
//         }

//         // Final check and action
//         if (isDataMissing) {
//             setIsDataValid(false);
//             console.error("Invalid Data:", { safeData, missingFields });
//             if (missingFields.length > 0) {
//                 Swal.fire({
//                     icon: "error",
//                     title: "Missing or Invalid Data",
//                     text: `Could not load required offer letter data (${missingFields.join(', ')}). Redirecting.`,
//                     confirmButtonText: "OK"
//                 }).then(() => { navigate("/letterform"); });
//             }
//         } else {
//             setIsDataValid(true); // All checks passed
//         }
//     }, [safeData, formData.section, navigate]); // Keep dependencies


//     // --- Page Calculation Effect ---
//     useEffect(() => {
//         if (!isDataValid || !measureRef.current) return;

//         setIsCalculatingPages(true);

//         if (safeData.generationMethod === 'custom' && safeData.customContent) {
//             setTimeout(() => {
//                 if (!measureRef.current) {
//                     setIsCalculatingPages(false);
//                     return;
//                 }

//                 const calculatedPages = [];
//                 const contentLines = safeData.customContent.split('\n');
//                 let currentPageContent = "";
//                 const measureDiv = measureRef.current;
//                 measureDiv.style.width = `${CONTENT_WIDTH_PX}px`; 
//                 measureDiv.innerHTML = ''; 

//                 contentLines.forEach((line) => {
//                     const contentWithNewLine = currentPageContent + (currentPageContent ? '\n' : '') + line;
//                     measureDiv.innerText = contentWithNewLine; 
//                     const estimatedHeight = measureDiv.scrollHeight; 

//                     const isFirstPage = calculatedPages.length === 0;
//                     const maxHeightForThisPage = isFirstPage ? MAX_CONTENT_FILL_HEIGHT_PAGE_1 : MAX_CONTENT_HEIGHT_SUBSEQUENT;

//                     if (estimatedHeight > maxHeightForThisPage && currentPageContent.trim()) {
//                         calculatedPages.push(currentPageContent);
//                         currentPageContent = line;
//                         measureDiv.innerText = line;
//                     } else {
//                         currentPageContent += (currentPageContent ? '\n' : '') + line;
//                     }
//                 });

//                 if (currentPageContent.trim()) {
//                     calculatedPages.push(currentPageContent);
//                 }

//                 setRenderedPagesData(calculatedPages); 
//                 setIsCalculatingPages(false);
//             }, 100); 

//         } else if (safeData.generationMethod === 'template') {
//              setRenderedPagesData(['template_content_placeholder']); 
//              setIsCalculatingPages(false);
//         } else {
//              setRenderedPagesData([]);
//              setIsCalculatingPages(false);
//         }
//     }, [isDataValid, safeData.generationMethod, safeData.customContent]);


//     // --- PDF Generation Function ---
//     const downloadAsPDF = async () => {
//         if (!offerLetterRef.current || !isDataValid || renderedPagesData.length === 0) {
//             Swal.fire("Error", "Cannot generate PDF. No content pages rendered or data is invalid.", "error");
//             return;
//         }
//         const elementToCapture = offerLetterRef.current;

//         const btn = document.getElementById('save-pdf-button-container');
//         if (btn) btn.style.visibility = 'hidden'; 

//         Swal.fire({
//             title: 'Generating PDF...',
//             text: 'Please wait while the offer letter is being processed.',
//             allowOutsideClick: false,
//             didOpen: () => { Swal.showLoading(); }
//         });

//         const opt = {
//             margin: 0,
//             filename: `${safeData.candidateName}_offer_letter.pdf`,
//             image: { type: "jpeg", quality: 0.98 },
//             html2canvas: {
//                 scale: 2, 
//                 useCORS: true, 
//                 logging: false, 
//                 scrollX: 0, 
//                 scrollY: 0,
//                 windowWidth: elementToCapture.scrollWidth, 
//             },
//             jsPDF: {
//                 unit: "px",
//                 format: [PAGE_WIDTH_PX, PAGE_HEIGHT_PX], 
//                 orientation: "portrait",
//             },
//         };

//         try {
//             await new Promise(resolve => setTimeout(resolve, 600));

//             const pdf = html2pdf().from(elementToCapture).set(opt);
//             const pdfBlob = await pdf.output('blob');

//             const formDataToSend = new FormData();
//             formDataToSend.append("pdf", pdfBlob, `${safeData.candidateName}_offer_letter.pdf`);
//             formDataToSend.append("candidateName", safeData.candidateName);
//             if (safeData.user_id) {
//                 formDataToSend.append("user_id", safeData.user_id);
//             }

//             const response = await axios.post(
//                 "https://raasbackend.vetrinahealthcare.com/save_pdf/", 
//                 formDataToSend,
//                 { headers: { "Content-Type": "multipart/form-data" } }
//             );

//             Swal.close();
//             if (btn) btn.style.visibility = 'visible'; 
//             Swal.fire({
//                 icon: "success",
//                 title: "Offer Letter PDF Saved!",
//                 text: response.data.message || "Saved successfully.",
//                 timer: 2500,
//                 timerProgressBar: true,
//                 showConfirmButton: false,
//             }).then(() => {
//                 navigate("/letterform"); 
//             });

//         } catch (error) {
//             if (btn) btn.style.visibility = 'visible'; 
//             Swal.close();
//             Swal.fire("PDF Generation Failed", `Error occurred. Please check console.`, "error");
//         }
//     };

//     // --- RENDER FUNCTIONS ---

//     // Header (FIXED: Handling dynamic address height)
//     const renderHeader = () => (
//         <>
//             <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX}px`, right: `${HEADER_CONTENT_RIGHT_MARGIN_PX}px`, width: "150px", textAlign: "right", zIndex: 2, fontSize: "10px" }}>Date - {safeData.date}</div>

//             <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 17}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, zIndex: 2, fontSize: "10px" }}>To,</div>

//             <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 32}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, fontWeight: "bold", zIndex: 2, fontSize: "10px" }}>{safeData.candidateName},</div>

//             {/* Address Block: Groups Address, Pin, and Phone so they flow vertically without overlapping */}
//             <div style={{ 
//                 position: "absolute", 
//                 top: `${HEADER_CONTENT_TOP_PX + 45}px`, 
//                 left: `${HEADER_CONTENT_LEFT_PX}px`, 
//                 width: `${CONTENT_WIDTH_PX}px`, 
//                 textAlign: "left", 
//                 zIndex: 2, 
//                 fontSize: "10px",
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "2px" // Minimal spacing between lines
//             }}>
//                 <div style={{ width: "100%", wordWrap: "break-word" }}>Address - {safeData.address}</div>
//                 <div>Pin code - {safeData.pinCode}</div>
//                 <div>Mobile No.: {safeData.mobileNumber}</div>
//             </div>
//         </>
//     );

//     // Footer
//     const renderFooter = () => (
//         <div style={{
//             position: 'absolute',
//             top: `${FOOTER_TOP_PX}px`, 
//             left: `${FOOTER_LEFT_PX}px`,
//             width: `${FOOTER_WIDTH_PX}px`,
//             zIndex: 2 
//         }}>
//             <div style={{ position: "absolute", top: `-30px`, left: `0px`, width: "100%", textAlign: "left", fontSize: "10px" }}>Thanks & Regards</div>

//             <div style={{ position: "absolute", top: `${STAMP_OFFSET_TOP_PX}px`, left: `${STAMP_OFFSET_LEFT_PX}px`, width: `${STAMP_WIDTH_PX}px`, height: `${STAMP_HEIGHT_PX}px`, zIndex: 3 }}>
//                 <img src={VetrinaStamp} alt="Vetrina Stamp" style={{ maxWidth: "120%", maxHeight: "120%" }} />
//             </div>

//             {safeData.signaturePreviewUrl && (
//                 <div style={{
//                     position: "absolute",
//                     top: `${SIGNATURE_OFFSET_TOP_PX}px`, 
//                     left: `${SIGNATURE_OFFSET_LEFT_PX}px`, 
//                     width: `${SIGNATURE_WIDTH_PX}px`,
//                     height: `${SIGNATURE_HEIGHT_PX}px`,
//                     zIndex: 3 
//                 }}>
//                     <img
//                         src={safeData.signaturePreviewUrl}
//                         alt="Signature Preview"
//                         style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
//                     />
//                 </div>
//             )}

//             <div style={{ position: "absolute", top: `40px`, left: `0px`, width: "100%", textAlign: "left", fontSize: "10px" }}>
//                 Mr / Mrs. {safeData.hrName} <br />
//                 {safeData.hrTitle}<br />
//                 Vetrina Healthcare Pvt. Ltd.
//             </div>
//         </div>
//     );

//     // Template Content
//     const renderTemplateContent = () => {
//         const topBase = CONTENT_TOP_PAGE_1_PX; 
//         const leftPos = CONTENT_LEFT_PX;
//         const width = CONTENT_WIDTH_PX;
//         return (
//             <>
//                 <div style={{ position: "absolute", top: `${topBase}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}><u>Subject: - Offer letter for the position of {safeData.position}.</u></div>
//                 <div style={{ position: "absolute", top: `${topBase + 40}px`, left: `${leftPos}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}>Dear Mr./Ms. {safeData.candidateName.split(' ')[0]},</div>
//                 <div style={{ position: "absolute", top: `${topBase + 80}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Based on our discussion in your interview we would like to offer you the position of <strong>{safeData.position} at VETRINA HEALTHCARE PVT. LTD.</strong> You will report to <strong>{safeData.reportingTo || '[Reporting Manager Name]'}</strong> who will define your roles and responsibility.</div>
//                 <div style={{ position: "absolute", top: `${topBase + 120}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Your annual CTC will be INR <strong>{safeData.salary} /- LAKH PER ANNUM.</strong> We will increase your salary, after analyzing your performance.</div>
//                 <div style={{ position: "absolute", top: `${topBase + 160}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Initially you will be based at HQ <strong>{safeData.basedHQ || '[Base HQ Name]'}.</strong> You will be responsible for the development of company business of Vetrina Healthcare Pvt. Ltd. You are liable to be transferred from time to time to other places as may be notified to you by company.</div>
//                 <div style={{ position: "absolute", top: `${topBase + 210}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>The company might pay variable bonus and incentives. This will be dependent on your performance in company in specific time frame. The decision to grant a bonus and the manner in which it will be calculated is at the sole discretion of the company and is not negotiable.</div>
//                 <div style={{ position: "absolute", top: `${topBase + 270}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>You will be required to abide by the rules and regulations of <strong>VETRINA HEALTHCARE PVT. LTD</strong>, that may be in force at the time of your appointment and also that may be promulgated from time to time thereafter.</div>
//             </>
//         );
//     };

//     // Custom Content
//     const renderCustomContent = (contentChunk, pageIndex) => {
//         const topMargin = pageIndex === 0 ? CONTENT_TOP_PAGE_1_PX : CONTENT_TOP_SUBSEQUENT_PX;
//         const leftPos = CONTENT_LEFT_PX;
//         const width = CONTENT_WIDTH_PX;

//         return (
//             <div style={{
//                 position: "absolute",
//                 top: `${topMargin}px`,
//                 left: `${leftPos}px`,
//                 width: `${width}px`,
//                 zIndex: 2,
//                 fontSize: "10px",
//                 lineHeight: "1.4", 
//                 textAlign: "justify",
//                 whiteSpace: "pre-wrap", 
//                 overflowWrap: "break-word", 
//             }}>
//                 {contentChunk}
//             </div>
//         );
//     }

//     if (!isDataValid && !isCalculatingPages) {
//         return (
//             <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
//                 <DashNavbar />
//                 <div style={{ display: "flex", flex: 1 }}>
//                     <Sidebar />
//                     <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
//                         <p>Validating data...</p>
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     return (
//          <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//             <DashNavbar />
//             <div style={{ display: "flex", flexGrow: 1 }}>
//                 <Sidebar />
//                 <div style={{
//                     flexGrow: 1,
//                     backgroundColor: "#e0e0e0", 
//                     padding: "30px 20px",
//                     overflowY: 'auto', 
//                     display: 'flex',
//                     flexDirection: 'column', 
//                     alignItems: 'center', 
//                     position: 'relative' 
//                 }}>

//                     <div
//                         id="save-pdf-button-container"
//                         style={{
//                             width: '100%', 
//                             maxWidth: `${PAGE_WIDTH_PX}px`, 
//                             display: 'flex',
//                             justifyContent: 'flex-end', 
//                             marginBottom: '20px', 
//                          }}
//                     >
//                         <Button
//                             onClick={downloadAsPDF}
//                             variant="primary"
//                             size="lg"
//                             disabled={isCalculatingPages || renderedPagesData.length === 0} 
//                         >
//                            {isCalculatingPages ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/> : <i className="fas fa-save me-2"></i>}
//                             Save Final PDF
//                         </Button>
//                     </div>

//                     <div
//                         ref={measureRef}
//                         style={{
//                             position: 'absolute',
//                             top: '-9999px',
//                             left: '-9999px',
//                             fontSize: '10px',
//                             lineHeight: '1.4',
//                             whiteSpace: 'pre-wrap',
//                             overflowWrap: 'break-word',
//                             zIndex: -1,
//                             fontFamily: "'Arial', sans-serif",
//                             visibility: 'hidden',
//                             width: `${CONTENT_WIDTH_PX}px`
//                         }}
//                     ></div>

//                     <div style={{
//                          width: `${PAGE_WIDTH_PX}px`, 
//                          display: 'flex',
//                          flexDirection: 'column',
//                          alignItems: 'center',
//                          boxShadow: '0 0 10px rgba(0,0,0,0.2)' 
//                     }}>
//                         <div
//                             ref={offerLetterRef}
//                             style={{
//                                 width: `${PAGE_WIDTH_PX}px`,
//                                 margin: 0,
//                                 padding: 0,
//                                 backgroundColor: '#fff',
//                                 lineHeight: 0, 
//                                 fontSize: 0, 
//                                 display: 'block', 
//                             }}
//                         >
//                             {isCalculatingPages ? (
//                                 <div style={{width: `${PAGE_WIDTH_PX}px`, height: `${PAGE_HEIGHT_PX}px`, display:'flex', justifyContent:'center', alignItems:'center', backgroundColor: '#fff'}}>
//                                     <Spinner animation="border" role="status">
//                                         <span className="visually-hidden">Calculating Pages...</span>
//                                     </Spinner>
//                                 </div>
//                             ) : renderedPagesData.length > 0 ? (
//                                 renderedPagesData.map((pageContent, index) => (
//                                     <div
//                                         key={index}
//                                         className="offer-letter-page"
//                                         style={{
//                                             width: `${PAGE_WIDTH_PX}px`,
//                                             height: `${PAGE_HEIGHT_PX}px`,
//                                             backgroundColor: "#ffffff",
//                                             position: "relative",
//                                             overflow: "hidden",
//                                             fontFamily: "'Arial', sans-serif",
//                                             fontSize: "10px",
//                                             color: "black",
//                                             lineHeight: "1.3",
//                                             boxSizing: "border-box",
//                                             margin: 0,
//                                             padding: 0,
//                                             display: 'block',
//                                         }}
//                                     >
//                                         <img
//                                             src={offerLetterBackgroundImage}
//                                             alt={`Background Page ${index + 1}`}
//                                             style={{
//                                                 position: 'absolute', top: 0, left: 0,
//                                                 width: '100%', height: '100%',
//                                                 objectFit: 'cover', zIndex: 1 
//                                             }}
//                                         />

//                                         {index === 0 && renderHeader()}

//                                         {safeData.generationMethod === 'template' && index === 0 ? (
//                                             renderTemplateContent()
//                                         ) : safeData.generationMethod === 'custom' ? (
//                                             renderCustomContent(pageContent, index)
//                                         ) : (
//                                             <p style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', zIndex:2, color:'red'}}>Invalid Generation Method</p>
//                                         )}

//                                         {index === renderedPagesData.length - 1 && renderFooter()}

//                                     </div>
//                                 )) 
//                             ) : null}
//                         </div> 
//                     </div> 
//                 </div> 
//             </div> 
//         </div> 
//     );
// };

// export default OfferLetter;



import React, { useRef, useEffect, useState, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Spinner } from "react-bootstrap";
import DashNavbar from "./DashNavbar";
import Sidebar from "./Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import offerLetterBackgroundImage from "../../Assets/Vetrina Offer Letter-1.png";
// Removed offerLetterBackgroundImage2 as pagination handles background per page now
import html2pdf from "html2pdf.js";
import axios from "axios";
import Swal from "sweetalert2";
import VetrinaStamp from "../../Assets/VetrinaStamp.png";

// =====================================================================
// ===== MANUAL LAYOUT CONFIGURATION (From Modified Code) =============
// =====================================================================
const PAGE_WIDTH_PX = 595;
const PAGE_HEIGHT_PX = 842;
const HEADER_CONTENT_LEFT_PX = 68;
const HEADER_CONTENT_RIGHT_MARGIN_PX = 60;
const HEADER_CONTENT_TOP_PX = 83;
const CONTENT_LEFT_PX = 68;
const CONTENT_WIDTH_PX = 475;
const CONTENT_TOP_PAGE_1_PX = 200; // Start content lower on page 1
const CONTENT_TOP_SUBSEQUENT_PX = 110; // Start content higher on subsequent pages
const CONTENT_BOTTOM_MARGIN_PX = 55; // Space before footer might start
const FOOTER_TOP_PX = 640; // Where the footer block starts (relative to page top)
const FOOTER_LEFT_PX = 68;
const FOOTER_WIDTH_PX = 475;
const STAMP_OFFSET_TOP_PX = -50; // Offset relative to FOOTER_TOP_PX (590px absolute)
const STAMP_OFFSET_LEFT_PX = 72; // Offset relative to FOOTER_LEFT_PX (140px absolute)
const STAMP_WIDTH_PX = 100;
const STAMP_HEIGHT_PX = 100;
const SIGNATURE_OFFSET_TOP_PX = -10; // Offset relative to FOOTER_TOP_PX (630px absolute)
const SIGNATURE_OFFSET_LEFT_PX = 0; // Offset relative to FOOTER_LEFT_PX (68px absolute)
const SIGNATURE_WIDTH_PX = 100;
const SIGNATURE_HEIGHT_PX = 50;
// =====================================================================
// ===== DERIVED CALCULATIONS (From Modified Code) ====================
// =====================================================================
// Cut off content at 570px (20px before stamp at 590px) to maximize page space while preventing stamp overlap
const FOOTER_AREA_TOP_PX = FOOTER_TOP_PX - 70; // 570px Y-coord
const MAX_CONTENT_FILL_HEIGHT_PAGE_1 = FOOTER_AREA_TOP_PX - CONTENT_TOP_PAGE_1_PX; // 370px max on page 1
const MAX_CONTENT_HEIGHT_SUBSEQUENT = FOOTER_AREA_TOP_PX - CONTENT_TOP_SUBSEQUENT_PX; // 460px max on subsequent pages
// =====================================================================

// --- Helper Functions ---
const formatDate = (date) => { // Using robust version from modified code
    if (!date) return "";
    try {
        if (typeof date === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
            return date;
        }
        const d = new Date(date);
        if (isNaN(d.getTime())) {
            const isoDate = new Date(Date.parse(date));
            if (isNaN(isoDate.getTime())) {
                console.warn("Invalid date:", date);
                return "Invalid Date";
            }
            const day = String(isoDate.getDate()).padStart(2, "0");
            const month = String(isoDate.getMonth() + 1).padStart(2, "0");
            const year = isoDate.getFullYear();
            return `${day}/${month}/${year}`;
        }
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    } catch (e) {
        console.error("Date format error:", date, e);
        return "Error Date";
    }
};

const cleanCustomContent = (html) => {
    if (!html) return "";
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html');
        const root = doc.body.firstElementChild;
        
        // Force font size of 8.5px, line-height of 1.2, and word-break on all table cells and headers
        const cells = root.querySelectorAll('td, th');
        cells.forEach(cell => {
            cell.style.fontSize = '8.5px';
            cell.style.lineHeight = '1.2';
            cell.style.wordBreak = 'break-word'; // cleaner than break-all, breaks long words only
            cell.style.overflowWrap = 'break-word';
        });
        
        const tables = root.querySelectorAll('table');
        tables.forEach(table => {
            table.style.fontSize = '8.5px';
            table.style.width = '100%';
            table.style.maxWidth = '100%';
            table.style.tableLayout = 'fixed'; // Force fixed layout so column widths are strictly followed
            table.style.borderCollapse = 'collapse';
            
            // Calculate column count and text distribution
            const rows = Array.from(table.querySelectorAll('tr'));
            if (rows.length === 0) return;
            
            let colCount = 0;
            rows.forEach(row => {
                colCount = Math.max(colCount, row.querySelectorAll('td, th').length);
            });
            
            if (colCount === 0) return;
            
            const maxLens = new Array(colCount).fill(0);
            rows.forEach(row => {
                const cols = row.querySelectorAll('td, th');
                cols.forEach((col, idx) => {
                    if (idx < colCount) {
                        maxLens[idx] = Math.max(maxLens[idx], col.textContent.trim().length);
                    }
                });
            });
            
            const paddedLens = maxLens.map(len => Math.max(len, 6)); // Minimum 6 characters weight
            const totalLen = paddedLens.reduce((sum, len) => sum + len, 0);
            
            let widths = paddedLens.map(len => (len / totalLen) * 100);
            
            // Enforce minimum width of 7% per column to prevent squashing
            let adjusted = false;
            for (let i = 0; i < widths.length; i++) {
                if (widths[i] < 7) {
                    widths[i] = 7;
                    adjusted = true;
                }
            }
            if (adjusted) {
                const sumAdjusted = widths.reduce((sum, w) => sum + w, 0);
                widths = widths.map(w => (w / sumAdjusted) * 100);
            }
            
            // Apply widths to cells in every row to satisfy all browser rendering engines
            rows.forEach(row => {
                const rowCells = row.querySelectorAll('td, th');
                rowCells.forEach((cell, idx) => {
                    if (idx < widths.length) {
                        cell.style.width = `${widths[idx].toFixed(2)}%`;
                    }
                });
            });
        });
        
        return root.innerHTML;
    } catch (e) {
        console.error("Error cleaning custom content:", e);
        return html;
    }
};

const OfferLetter = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const formData = location.state || {};
    const offerLetterRef = useRef(null);
    const measureRef = useRef(null); // For custom content pagination measurement

    const [renderedPagesData, setRenderedPagesData] = useState([]);
    const [isCalculatingPages, setIsCalculatingPages] = useState(false);
    const [isDataValid, setIsDataValid] = useState(false);

    // Use memoized safeData for stability (From Modified Code)
    const safeData = useMemo(() => ({
        candidateName: formData.candidateName || "Candidate Name",
        date: formatDate(formData.date),
        address: formData.address || "[Address]",
        pinCode: formData.pinCode || "[Pin Code]",
        mobileNumber: formData.mobileNumber || "[Mobile Number]",
        hrName: formData.hr?.name || "[HR Manager Name]",
        hrTitle: "HR Executive", // Assuming constant title
        position: formData.position || "[Position]", // Used by template
        salary: formData.salary || "[N/A]",         // Used by template
        reportingTo: formData.reporting_manager || "[Reporting Manager]", // Used by template
        basedHQ: formData.headquarter || "[Base HQ]", // Used by template
        customContent: cleanCustomContent(formData.customContent || ""),   // Cleaned custom content
        generationMethod: formData.generationMethod,
        signaturePreviewUrl: formData.signaturePreviewUrl || null,
        user_id: formData.user_id,
    }), [formData]);

    // --- Data Validation Effect (From Modified Code - More Robust) ---
    useEffect(() => {
        console.log("OfferLetter State:", formData);
        let isDataMissing = false;
        let missingFields = [];

        // Basic checks (needed for both)
        if (!safeData.candidateName || safeData.candidateName === "Candidate Name") { isDataMissing = true; missingFields.push('candidateName'); }
        if (!safeData.date || safeData.date === "Invalid Date" || safeData.date === "Error Date") { isDataMissing = true; missingFields.push('date'); }
        if (!safeData.hrName || safeData.hrName === "[HR Manager Name]") { isDataMissing = true; missingFields.push('hr'); }
        // Signature is needed for footer
        if (!safeData.signaturePreviewUrl) { isDataMissing = true; missingFields.push('signature'); }

        // Template specific checks
        if (safeData.generationMethod === 'template') {
            const flds = ['position', 'salary', 'address', 'pinCode', 'mobileNumber', 'reportingTo', 'basedHQ']; // Add all template fields
            flds.forEach(f => {
                const value = safeData[f];
                if (!value || (typeof value === 'string' && value.startsWith('[')) || value === "Candidate Name" || value === "[N/A]") { // Added more checks
                    isDataMissing = true;
                    if (!missingFields.includes(f)) missingFields.push(f);
                }
            });
        }
        // Custom specific checks
        else if (safeData.generationMethod === 'custom') {
            if (!safeData.customContent) {
                isDataMissing = true;
                if (!missingFields.includes('customContent')) missingFields.push('customContent');
            }
            // Custom also needs address details for header
            const headerFields = ['address', 'pinCode', 'mobileNumber'];
            headerFields.forEach(f => {
                const value = safeData[f];
                if (!value || (typeof value === 'string' && value.startsWith('['))) {
                    isDataMissing = true;
                    if (!missingFields.includes(f)) missingFields.push(f);
                }
            });
        }
        // Check if generationMethod itself is missing/invalid
        else {
            isDataMissing = true;
            missingFields.push('generationMethod');
        }

        // Check section type (optional robustness check)
        const isIncorrectSection = formData.section !== 'Offer Letter';
        if (isIncorrectSection) {
            console.error("Incorrect section type detected:", formData.section);
            // Optionally add: isDataMissing = true; if (!missingFields.includes('section')) missingFields.push('section');
        }

        // Final check and action
        if (isDataMissing) {
            setIsDataValid(false);
            console.error("Invalid Data:", { safeData, missingFields, isIncorrectSection });
            // Show error only if critical data is missing
            if (missingFields.length > 0) {
                Swal.fire({
                    icon: "error",
                    title: "Missing or Invalid Data",
                    text: `Could not load required offer letter data (${missingFields.join(', ')}). Redirecting.`,
                    confirmButtonText: "OK"
                }).then(() => { navigate("/letterform"); });
            }
        } else {
            setIsDataValid(true); // All checks passed
        }
    }, [safeData, formData.section, navigate]); // Keep dependencies


    // --- Page Calculation Effect (From Modified Code - Handles Custom Pagination) ---
    useEffect(() => {
        if (!isDataValid || !measureRef.current) return;

        // Always start calculation if data is valid
        setIsCalculatingPages(true);

        if (safeData.generationMethod === 'custom' && safeData.customContent) {
            setTimeout(() => {
                if (!measureRef.current) {
                    console.error("Measure ref disappeared during calculation.");
                    setIsCalculatingPages(false);
                    setRenderedPagesData([]);
                    return;
                }

                const isHtml = /<[a-z][\s\S]*>/i.test(safeData.customContent);
                let contentBlocks = [];
                if (isHtml) {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(`<div>${safeData.customContent}</div>`, 'text/html');
                  const root = doc.body.firstElementChild;

                  const isBlockElement = (node) => {
                    if (node.nodeType !== Node.ELEMENT_NODE) return false;
                    const tag = node.tagName.toLowerCase();
                    return ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'ul', 'ol', 'pre', 'blockquote'].includes(tag);
                  };

                  const traverse = (node) => {
                    if (isBlockElement(node)) {
                      let wrapper = node.cloneNode(true);
                      let ancestor = node.parentNode;
                      while (ancestor && ancestor !== root) {
                        if (ancestor.nodeType === Node.ELEMENT_NODE) {
                          const tag = ancestor.tagName.toLowerCase();
                          if (ancestor.attributes.length > 0 || ['span', 'font', 'b', 'i', 'u', 'strike', 'strong', 'em'].includes(tag)) {
                            const ancestorClone = ancestor.cloneNode(false);
                            ancestorClone.appendChild(wrapper);
                            wrapper = ancestorClone;
                          }
                        }
                        ancestor = ancestor.parentNode;
                      }
                      contentBlocks.push(wrapper.outerHTML);
                      return;
                    }

                    if (node.nodeType === Node.TEXT_NODE && node.textContent && node.textContent.trim()) {
                      const p = doc.createElement('p');
                      p.textContent = node.textContent.trim();
                      let wrapper = p;
                      let ancestor = node.parentNode;
                      while (ancestor && ancestor !== root) {
                        if (ancestor.nodeType === Node.ELEMENT_NODE) {
                          const tag = ancestor.tagName.toLowerCase();
                          if (ancestor.attributes.length > 0 || ['span', 'font', 'b', 'i', 'u', 'strike', 'strong', 'em'].includes(tag)) {
                            const ancestorClone = ancestor.cloneNode(false);
                            ancestorClone.appendChild(wrapper);
                            wrapper = ancestorClone;
                          }
                        }
                        ancestor = ancestor.parentNode;
                      }
                      contentBlocks.push(wrapper.outerHTML);
                      return;
                    }

                    if (node.childNodes && node.childNodes.length > 0) {
                      Array.from(node.childNodes).forEach(child => traverse(child));
                    }
                  };

                  Array.from(root.childNodes).forEach(child => traverse(child));

                  if (contentBlocks.length === 0) {
                    contentBlocks = [safeData.customContent];
                  }
                } else {
                  contentBlocks = safeData.customContent.split('\n');
                }

                const calculatedPages = [];
                let currentPageContent = "";
                const measureDiv = measureRef.current;
                measureDiv.style.width = `${CONTENT_WIDTH_PX}px`;
                measureDiv.style.fontSize = "10px";
                measureDiv.style.lineHeight = "1.4";
                measureDiv.style.fontFamily = "'Arial', sans-serif";
                measureDiv.style.whiteSpace = isHtml ? "normal" : "pre-wrap";
                measureDiv.innerHTML = '';

                const processBlockList = (blocks) => {
                  let currentContent = "";

                  blocks.forEach((block) => {
                    const isTableBlock = isHtml && /^<table/i.test(block.trim());
                    const candidateContent = currentContent + (currentContent && !isHtml ? '\n' : '') + block;

                    if (isHtml) {
                      measureDiv.innerHTML = candidateContent;
                    } else {
                      measureDiv.innerText = candidateContent;
                    }
                    const estimatedHeight = measureDiv.scrollHeight;

                    const isFirstPage = calculatedPages.length === 0;
                    const maxHeightForThisPage = isFirstPage ? MAX_CONTENT_FILL_HEIGHT_PAGE_1 : MAX_CONTENT_HEIGHT_SUBSEQUENT;

                    if (estimatedHeight > maxHeightForThisPage) {
                      // If the block is a table and doesn't fit on the current page as a whole,
                      // split the table row-by-row so rows that fit remain on the current page!
                      if (isTableBlock) {
                        try {
                          const parser = new DOMParser();
                          const tableDoc = parser.parseFromString(block, 'text/html');
                          const tableEl = tableDoc.querySelector('table');
                          const rows = Array.from(tableEl ? tableEl.querySelectorAll('tr') : []);

                          if (rows.length > 2) {
                            const headerRowHtml = rows[0].outerHTML;
                            const dataRows = rows.slice(1);

                            const createTableString = (rowHtmlList) => {
                              const clone = tableEl.cloneNode(false);
                              clone.innerHTML = `<tbody>${rowHtmlList.join('')}</tbody>`;
                              return clone.outerHTML;
                            };

                            let fitRows = [headerRowHtml];
                            let remainingRows = [];
                            let splitSuccess = false;

                            for (let r = 0; r < dataRows.length; r++) {
                              const testRows = fitRows.concat(dataRows[r].outerHTML);
                              const testTableHtml = createTableString(testRows);
                              measureDiv.innerHTML = currentContent + testTableHtml;

                              if (measureDiv.scrollHeight <= maxHeightForThisPage) {
                                fitRows.push(dataRows[r].outerHTML);
                                splitSuccess = true;
                              } else {
                                remainingRows = dataRows.slice(r).map(row => row.outerHTML);
                                break;
                              }
                            }

                            if (splitSuccess && fitRows.length > 1 && remainingRows.length > 0) {
                              // Table Part 1 fits on current page!
                              const part1Html = createTableString(fitRows);
                              currentContent += (currentContent ? '\n' : '') + part1Html;
                              calculatedPages.push(currentContent);
                              currentContent = "";

                              // Table Part 2 moves to next page (with table headers repeated!)
                              const part2Html = createTableString([headerRowHtml].concat(remainingRows));
                              processBlockList([part2Html]);
                              return;
                            }
                          }
                        } catch (err) {
                          console.error("Error splitting table rows:", err);
                        }
                      }

                      // Normal block split
                      if (currentContent.trim()) {
                        calculatedPages.push(currentContent);
                        currentContent = block;
                        if (isHtml) {
                          measureDiv.innerHTML = block;
                        } else {
                          measureDiv.innerText = block;
                        }
                      } else {
                        currentContent = block;
                      }
                    } else {
                      currentContent += (currentContent && !isHtml ? '\n' : '') + block;
                    }
                  });

                  if (currentContent.trim()) {
                    calculatedPages.push(currentContent);
                  }
                };

                processBlockList(contentBlocks);

                setRenderedPagesData(calculatedPages);
                setIsCalculatingPages(false);
                console.log(`Custom content calculation resulted in ${calculatedPages.length} pages.`);

            }, 100); // Small delay for rendering updates

        } else if (safeData.generationMethod === 'template') {
            // Template currently assumed to fit on one page
            setRenderedPagesData(['template_content_placeholder']); // Placeholder indicates one page for template
            setIsCalculatingPages(false);
            console.log("Using single page structure for template.");
        } else {
            // Should not happen if validation is correct, but handle defensively
            setRenderedPagesData([]);
            setIsCalculatingPages(false);
            console.warn("No valid generation method for page calculation.");
        }
        // IMPORTANT: Dependencies ensure recalculation if custom content or method changes
    }, [isDataValid, safeData.generationMethod, safeData.customContent]);


    // --- PDF Generation Function ---
    const downloadAsPDF = async () => {
        if (!offerLetterRef.current || !isDataValid || renderedPagesData.length === 0) {
            Swal.fire("Error", "Cannot generate PDF. No content pages rendered or data is invalid.", "error");
            return;
        }

        if (!safeData.candidateName || safeData.candidateName === "Candidate Name" || !safeData.hrName || safeData.hrName === "[HR Manager Name]") {
            Swal.fire("Error", "Cannot generate PDF. Missing candidate name or HR name.", "error");
            return;
        }

        const btn = document.getElementById('save-pdf-button-container');
        if (btn) btn.style.visibility = 'hidden';

        Swal.fire({
            title: 'Generating PDF...',
            text: 'Please wait while the offer letter is being processed.',
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading(); }
        });

        const elementToCapture = offerLetterRef.current;
        const scrollableParent = elementToCapture.parentElement?.parentElement;
        const originalScrollTop = scrollableParent ? scrollableParent.scrollTop : 0;
        if (scrollableParent) scrollableParent.scrollTop = 0;
        window.scrollTo(0, 0);

        const opt = {
            margin: 0,
            filename: `${safeData.candidateName}_offer_letter.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                logging: false,
                scrollX: 0,
                scrollY: 0,
                windowWidth: PAGE_WIDTH_PX,
            },
            jsPDF: {
                unit: "px",
                format: [PAGE_WIDTH_PX, PAGE_HEIGHT_PX],
                orientation: "portrait",
            },
            pagebreak: { mode: ['css', 'legacy'] }
        };

        try {
            await new Promise(resolve => setTimeout(resolve, 600));

            const pdfBlob = await html2pdf().from(elementToCapture).set(opt).output('blob');

            if (scrollableParent) scrollableParent.scrollTop = originalScrollTop;

            if (!pdfBlob || pdfBlob.size === 0) {
                throw new Error("Generated PDF blob is empty.");
            }

            const formDataToSend = new FormData();
            formDataToSend.append("pdf", pdfBlob, `${safeData.candidateName}_offer_letter.pdf`);
            formDataToSend.append("candidateName", safeData.candidateName);
            if (safeData.user_id) {
                formDataToSend.append("user_id", safeData.user_id);
            }
            if (safeData.letter_id) {
                formDataToSend.append("letter_id", safeData.letter_id);
            }

            console.log("Sending Offer Letter PDF to backend...");
            const response = await axios.post(
                "https://raasbackend.vetrinahealthcare.com/save_pdf/",
                formDataToSend,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            Swal.close();
            if (btn) btn.style.visibility = 'visible';
            Swal.fire({
                icon: "success",
                title: "Offer Letter PDF Saved!",
                text: response.data.message || "The generated PDF has been saved successfully.",
                timer: 2500,
                timerProgressBar: true,
                showConfirmButton: false,
            }).then(() => {
                navigate("/letterform");
            });

        } catch (error) {
            if (btn) btn.style.visibility = 'visible';
            Swal.close();
            console.error("Error during PDF generation or saving:", error);
            const errorText = error.response?.data?.error || error.message || "An unexpected error occurred during PDF generation or saving.";
            Swal.fire("PDF Generation Failed", `Error: ${errorText}. Please check console logs.`, "error");
        }
    };

    // --- RENDER FUNCTIONS ---

    // Header (From Modified Code - uses constants)
    const renderHeader = () => (
        <>
            <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX}px`, right: `${HEADER_CONTENT_RIGHT_MARGIN_PX}px`, width: "150px", textAlign: "right", zIndex: 2, fontSize: "10px" }}>Date - {safeData.date}</div>

            <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 17}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, zIndex: 2, fontSize: "10px" }}>To,</div>

            <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 32}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, fontWeight: "bold", zIndex: 2, fontSize: "10px" }}>{safeData.candidateName},</div>

            {/* Address Block: Groups Address, Pin, and Phone so they flow vertically without overlapping */}
            <div style={{
                position: "absolute",
                top: `${HEADER_CONTENT_TOP_PX + 45}px`,
                left: `${HEADER_CONTENT_LEFT_PX}px`,
                width: `${CONTENT_WIDTH_PX}px`,
                textAlign: "left",
                zIndex: 2,
                fontSize: "10px",
                display: "flex",
                flexDirection: "column",
                gap: "2px" // Minimal spacing between lines
            }}>
                <div style={{ width: "100%", wordWrap: "break-word" }}>Address - {safeData.address}</div>
                <div>Pin code - {safeData.pinCode}</div>
                <div>Mobile No.: {safeData.mobileNumber}</div>
            </div>
        </>
    );

    // Footer (From Modified Code - uses constants and signature placement)
    const renderFooter = () => (
        <div style={{
            position: 'absolute',
            top: `${FOOTER_TOP_PX}px`, // Position the whole footer block
            left: `${FOOTER_LEFT_PX}px`,
            width: `${FOOTER_WIDTH_PX}px`,
            zIndex: 2 // Ensure footer text is above background
        }}>
            {/* Position elements *relative* to the footer block's top/left */}
            {/* <div style={{ position: "absolute", top: `-70px`, left: `0px`, width: "100%", textAlign: "justify", fontSize: "10px" }}>If you have any question or concerns, please feel free to contact us.</div> */}
            <div style={{ position: "absolute", top: `-30px`, left: `0px`, width: "100%", textAlign: "left", fontSize: "10px" }}>Thanks & Regards</div>

            {/* Stamp Image */}
            <div style={{ position: "absolute", top: `${STAMP_OFFSET_TOP_PX}px`, left: `${STAMP_OFFSET_LEFT_PX}px`, width: `${STAMP_WIDTH_PX}px`, height: `${STAMP_HEIGHT_PX}px`, zIndex: 3 /* Above text */ }}>
                <img src={VetrinaStamp} alt="Vetrina Stamp" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            </div>

            {/* Signature Image */}
            {safeData.signaturePreviewUrl && (
                <div style={{
                    position: "absolute",
                    top: `${SIGNATURE_OFFSET_TOP_PX}px`, // Relative to footer top
                    left: `${SIGNATURE_OFFSET_LEFT_PX}px`, // Relative to footer left
                    width: `${SIGNATURE_WIDTH_PX}px`,
                    height: `${SIGNATURE_HEIGHT_PX}px`,
                    zIndex: 3 /* Above text */
                }}>
                    <img
                        src={safeData.signaturePreviewUrl}
                        alt="Signature Preview"
                        style={{ width: "100%", height: "100%", objectFit: "contain" }}
                    />
                </div>
            )}

            {/* HR Name and Title Text */}
            <div style={{ position: "absolute", top: `40px`, left: `0px`, width: "100%", textAlign: "left", fontSize: "10px" }}>
                Mr / Mrs. {safeData.hrName} <br />
                {safeData.hrTitle}<br />
                Vetrina Healthcare Pvt. Ltd.
            </div>
        </div>
    );

    // Template Content Rendering (Using Original Code's structure, adapted with constants)
    const renderTemplateContent = () => {
        const topBase = CONTENT_TOP_PAGE_1_PX; // Template content starts at this Y position on page 1
        const leftPos = CONTENT_LEFT_PX;
        const width = CONTENT_WIDTH_PX;
        return (
            <>
                {/* Content structure directly from Original Code */}
                <div style={{ position: "absolute", top: `${topBase}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}><u>Subject: - Offer letter for the position of {safeData.position}.</u></div>
                <div style={{ position: "absolute", top: `${topBase + 40}px`, left: `${leftPos}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}>Dear Mr./Ms. {safeData.candidateName.split(' ')[0]},</div>
                <div style={{ position: "absolute", top: `${topBase + 80}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Based on our discussion in your interview we would like to offer you the position of <strong>{safeData.position} at VETRINA HEALTHCARE PVT. LTD.</strong> You will report to <strong>{safeData.reportingTo || '[Reporting Manager Name]'}</strong> who will define your roles and responsibility.</div>
                <div style={{ position: "absolute", top: `${topBase + 120}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Your annual CTC will be INR <strong>{safeData.salary} /-PER ANNUM.</strong> We will increase your salary, after analyzing your performance.</div>
                <div style={{ position: "absolute", top: `${topBase + 160}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Initially you will be based at HQ <strong>{safeData.basedHQ || '[Base HQ Name]'}.</strong> You will be responsible for the development of company business of Vetrina Healthcare Pvt. Ltd. You are liable to be transferred from time to time to other places as may be notified to you by company.</div>
                <div style={{ position: "absolute", top: `${topBase + 210}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>The company might pay variable bonus and incentives. This will be dependent on your performance in company in specific time frame. The decision to grant a bonus and the manner in which it will be calculated is at the sole discretion of the company and is not negotiable.</div>
                <div style={{ position: "absolute", top: `${topBase + 270}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>You will be required to abide by the rules and regulations of <strong>VETRINA HEALTHCARE PVT. LTD</strong>, that may be in force at the time of your appointment and also that may be promulgated from time to time thereafter.</div>
            </>
        );
    };

    // Custom Content Rendering (From Modified Code - handles pagination)
    const renderCustomContent = (contentChunk, pageIndex) => {
        const topMargin = pageIndex === 0 ? CONTENT_TOP_PAGE_1_PX : CONTENT_TOP_SUBSEQUENT_PX;
        const leftPos = CONTENT_LEFT_PX;
        const width = CONTENT_WIDTH_PX;
        const isHtml = /<[a-z][\s\S]*>/i.test(contentChunk);

        return (
            <div 
                className="offer-letter-custom-content"
                style={{
                    position: "absolute",
                    top: `${topMargin}px`,
                    left: `${leftPos}px`,
                    width: `${width}px`,
                    zIndex: 2,
                    fontSize: "10px",
                    lineHeight: "1.4",
                    textAlign: "justify",
                    whiteSpace: isHtml ? "normal" : "pre-wrap",
                    overflowWrap: "break-word",
                }}
                dangerouslySetInnerHTML={{ __html: contentChunk }}
            />
        );
    }

    // --- Main Render Logic ---

    // Loading/Redirecting state before data is validated
    if (!isDataValid && !isCalculatingPages) { // Show loading only if not validated AND not calculating
        return (
            <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
                <DashNavbar />
                <div style={{ display: "flex", flex: 1 }}>
                    <Sidebar />
                    <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
                        <p>Validating data or redirecting...</p>
                        {/* Optionally add a spinner here too */}
                    </div>
                </div>
            </div>
        );
    }

    // Main component render
    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
            <style>{`
                .offer-letter-custom-content table, .offer-letter-page table {
                  width: 100% !important;
                  max-width: 100% !important;
                  table-layout: fixed !important;
                  border-collapse: collapse !important;
                  margin-top: 6px !important;
                  margin-bottom: 8px !important;
                  font-size: 8.5px !important;
                }
                .offer-letter-custom-content td, .offer-letter-custom-content th,
                .offer-letter-page td, .offer-letter-page th {
                  border: 1px solid #000000 !important;
                  padding: 3px 4px !important;
                  text-align: left !important;
                  vertical-align: top !important;
                  font-size: 8.5px !important;
                  word-break: break-all !important;
                  overflow-wrap: break-word !important;
                }
                .offer-letter-custom-content th, .offer-letter-page th {
                  background-color: #f2f2f2 !important;
                  font-weight: bold !important;
                }
            `}</style>
            <DashNavbar />
            <div style={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>
                <Sidebar />
                {/* Main Content Area */}
                <div style={{
                    flexGrow: 1,
                    backgroundColor: "#e0e0e0", // Grey background for contrast
                    padding: "30px 20px",
                    overflowY: 'auto', // Allow scrolling the whole preview area if needed
                    display: 'flex',
                    flexDirection: 'column', // Stack button and letter vertically
                    alignItems: 'center', // Center the letter preview horizontally
                    position: 'relative' // Needed for absolute positioning of button and measure div
                }}>

                    {/* Save Button (Positioned top-right relative to content area) */}
                    <div
                        id="save-pdf-button-container"
                        style={{
                            width: '100%', // Take full width of container
                            maxWidth: `${PAGE_WIDTH_PX}px`, // Align with letter width
                            display: 'flex',
                            justifyContent: 'flex-end', // Push button to the right
                            marginBottom: '20px', // Space below button
                            paddingRight: '0px' // Align button edge with letter edge
                        }}
                    >
                        <Button
                            onClick={downloadAsPDF}
                            variant="primary"
                            size="lg"
                            disabled={isCalculatingPages || renderedPagesData.length === 0} // Disable while calculating or if no pages
                        >
                            {isCalculatingPages ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" /> : <i className="fas fa-save me-2"></i>}
                            Save Final PDF
                        </Button>
                    </div>

                    {/* Hidden Measurement Div (Crucial for custom pagination) */}
                    <div
                        ref={measureRef}
                        className="offer-letter-custom-content"
                        style={{
                            position: 'absolute',
                            top: '-9999px', // Off-screen
                            left: '-9999px', // Off-screen
                            fontSize: '10px', // Must match rendered content
                            lineHeight: '1.4', // Must match rendered content
                            overflowWrap: 'break-word', // Must match rendered content
                            zIndex: -1, // Behind everything
                            fontFamily: "'Arial', sans-serif", // Match font
                            visibility: 'hidden', // Hide visually
                            width: `${CONTENT_WIDTH_PX}px` // Critical: Set width for height calc
                        }}
                    ></div>

                    {/* Letter Preview Container */}
                    <div style={{
                        width: `${PAGE_WIDTH_PX}px`, // Fixed width
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        boxShadow: '0 0 10px rgba(0,0,0,0.2)' // Visual separation
                    }}>
                        {/* Container Ref for PDF generation (Contains all pages) */}
                        <div
                            ref={offerLetterRef}
                            style={{
                                width: `${PAGE_WIDTH_PX}px`,
                                margin: 0,
                                padding: 0,
                                backgroundColor: '#fff',
                                lineHeight: 0, // Reset line height for container
                                fontSize: 0, // Reset font size for container
                                display: 'block', // Ensure it behaves like a block
                            }}
                        >
                            {/* Render Pages based on calculation */}
                            {isCalculatingPages ? (
                                // Show spinner covering the first page area while calculating
                                <div style={{ width: `${PAGE_WIDTH_PX}px`, height: `${PAGE_HEIGHT_PX}px`, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden">Calculating Pages...</span>
                                    </Spinner>
                                </div>
                            ) : renderedPagesData.length > 0 ? (
                                // Map over the calculated page data
                                renderedPagesData.map((pageContent, index) => (
                                    <div
                                        key={index}
                                        className="offer-letter-page" // Useful for potential CSS targeting
                                        style={{
                                            width: `${PAGE_WIDTH_PX}px`,
                                            height: `${PAGE_HEIGHT_PX}px`,
                                            backgroundColor: "#ffffff", // White background for each page
                                            position: "relative", // Needed for absolute positioning of content inside
                                            overflow: "hidden", // Clip content that might overflow page boundaries
                                            fontFamily: "'Arial', sans-serif", // Base font
                                            fontSize: "10px", // Base font size
                                            color: "black",
                                            lineHeight: "1.3", // Base line height
                                            boxSizing: "border-box", // Include padding/border in size
                                            margin: 0, // No margin between pages
                                            padding: 0, // No padding on the page div itself
                                            display: 'block', // Ensure div takes up block space
                                            // pageBreakAfter: 'always' // Hint for printing/PDF - handled by html2pdf structure
                                        }}
                                    >
                                        {/* Background Image for EVERY page */}
                                        <img
                                            src={offerLetterBackgroundImage}
                                            alt={`Background Page ${index + 1}`}
                                            style={{
                                                position: 'absolute', top: 0, left: 0,
                                                width: '100%', height: '100%',
                                                objectFit: 'cover', zIndex: 1 // Behind content
                                            }}
                                        />

                                        {/* Render Header ONLY on the first page (index 0) */}
                                        {index === 0 && renderHeader()}

                                        {/* Render Content based on Generation Method */}
                                        {safeData.generationMethod === 'template' && index === 0 ? (
                                            // Template content only goes on the first page
                                            renderTemplateContent()
                                        ) : safeData.generationMethod === 'custom' ? (
                                            // Custom content is rendered per calculated page chunk
                                            renderCustomContent(pageContent, index)
                                        ) : (
                                            // Fallback if method is somehow invalid (shouldn't happen with validation)
                                            <p style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', zIndex: 2, color: 'red' }}>Invalid Generation Method</p>
                                        )}

                                        {/* Render Footer ONLY on the LAST page */}
                                        {index === renderedPagesData.length - 1 && renderFooter()}

                                    </div> // End individual page div
                                )) // End map loop
                            ) : (
                                // Case where calculation finished but resulted in zero pages (e.g., empty custom content)
                                <div style={{ width: `${PAGE_WIDTH_PX}px`, height: `${PAGE_HEIGHT_PX}px`, backgroundColor: "#ffffff", position: "relative", overflow: "hidden" }}>
                                    <img src={offerLetterBackgroundImage} alt="Background Page 1" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }} />
                                    <p style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2, color: 'grey' }}>No content to display. Check input data.</p>
                                </div>
                            )}
                        </div> {/* End Ref Container (offerLetterRef) */}
                    </div> {/* End Letter Preview Container */}
                </div> {/* End Main Content Area */}
            </div> {/* End flex row (Sidebar + Content) */}
        </div> /* End outer container */
    );
};

export default OfferLetter;









// // // OfferLetter.js
// // import React, { useRef, useEffect } from "react";
// // import "bootstrap/dist/css/bootstrap.min.css";
// // import { Button } from "react-bootstrap";
// // import DashNavbar from "./DashNavbar";
// // import Sidebar from "./Sidebar";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import offerLetterBackgroundImage from "../../Assets/Vetrina Offer Letter-1.png";
// // import offerLetterBackgroundImage2 from "../../Assets/Vetrina Offer Letter-2.png";
// // import html2pdf from "html2pdf.js";
// // import axios from "axios";
// // import Swal from "sweetalert2";
// // import VetrinaStamp from "../../Assets/VetrinaStamp.png";

// // // --- Helper Functions (Keep as before) ---
// // const formatDate = (date) => {
// //     // ... (formatDate function) ...
// //     if (!date) return "";
// //     try {
// //         const d = new Date(date);
// //         if (isNaN(d.getTime())) {
// //             console.warn("Invalid date received:", date);
// //             return "Invalid Date";
// //         }
// //         const day = String(d.getDate()).padStart(2, "0");
// //         const month = String(d.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
// //         const year = d.getFullYear();
// //         return `${day}/${month}/${year}`;
// //     } catch (e) {
// //         console.error("Error formatting date:", date, e);
// //         return "Error Date";
// //     }
// // };

// // const OfferLetter = () => {
// //     const location = useLocation();
// //     const navigate = useNavigate();
// //     const formData = location.state || {};
// //     const offerLetterRef = useRef(null);

// //     // --- Data Validation Effect (Keep as before) ---
// //     useEffect(() => {
// //         // ... (validation logic) ...
// //         const requiredFields = ['candidateName', 'position', 'salary', 'date', 'hr', 'address', 'pinCode', 'mobileNumber'];
// //         const isDataMissing = !formData || requiredFields.some(field => !formData[field]);
// //         const isIncorrectSection = formData.section !== 'Offer Letter';

// //         if (isDataMissing || isIncorrectSection) {
// //             console.error("OfferLetter: Missing required data or incorrect letter type.", { formData });
// //             Swal.fire({
// //                 icon: "error",
// //                 title: "Missing or Invalid Data",
// //                 text: "Could not load all required offer letter data or incorrect type specified. Redirecting back.",
// //                 confirmButtonText: "OK"
// //             }).then(() => {
// //                 navigate("/letterform");
// //             });
// //         }
// //     }, [formData, navigate]);

// //     // --- PDF Generation Function (Trying Legacy Mode + Negative Margin) ---
// //     const downloadAsPDF = async () => {
// //         const elementToCapture = offerLetterRef.current;

// //         if (!elementToCapture) {
// //             Swal.fire("Error", "Cannot generate PDF. Letter element not found.", "error");
// //             return;
// //         }
// //         // ... (other checks) ...
// //         if (!formData || !formData.candidateName) {
// //             Swal.fire("Error", "Cannot generate PDF. Missing candidate data.", "error");
// //             return;
// //         }


// //         Swal.fire({
// //             title: 'Generating PDF...',
// //             text: 'Please wait while the offer letter is being generated.',
// //             allowOutsideClick: false,
// //             didOpen: () => { Swal.showLoading(); }
// //         });

// //         // --- html2pdf.js Options (Trying Legacy Mode) ---
// //         const opt = {
// //             margin: 0,
// //             filename: `${formData.candidateName}_offer_letter.pdf`,
// //             image: { type: "jpeg", quality: 0.98 },
// //             html2canvas: {
// //                 scale: 2,
// //                 useCORS: true,
// //                 logging: true,
// //                 width: 595,
// //                 scrollX: 0,
// //                 scrollY: 0,
// //                 // Maybe explicitly tell it the full height it needs to capture?
// //                 // windowHeight: elementToCapture.scrollHeight // or 842 * 2 = 1684
// //             },
// //             jsPDF: {
// //                 unit: "px",
// //                 format: [595, 842],
// //                 orientation: "portrait",
// //             },
// //             // *** Key Change: Switch to 'legacy' mode ***
// //             // This uses a different internal algorithm for page breaks
// //             pagebreak: {
// //                  mode: 'legacy',
// //                  // We still rely on the CSS page-break-after on the first div
// //             }
// //         };

// //         try {
// //             console.log("Capturing element:", elementToCapture);
// //             console.log("Using options:", opt);

// //             const pdfBlob = await html2pdf()
// //                 .from(elementToCapture)
// //                 .set(opt)
// //                 .output('blob');

// //             console.log("PDF Blob created, size:", pdfBlob.size);

// //             // --- Optional Debug Download Link ---
// //             // const url = URL.createObjectURL(pdfBlob);
// //             // const a = document.createElement("a");
// //             // a.href = url;
// //             // a.download = `${formData.candidateName}_offer_letter_DEBUG_LEGACY_MODE.pdf`;
// //             // document.body.appendChild(a);
// //             // a.click();
// //             // document.body.removeChild(a);
// //             // URL.revokeObjectURL(url);
// //             // console.log("Debug download link triggered and removed.");
// //             // --- End Debug ---


// //             // --- Prepare FormData and Send to Backend (Keep as before) ---
// //             const formDataToSend = new FormData();
// //             // ... (append data) ...
// //             formDataToSend.append("pdf", pdfBlob, `${formData.candidateName}_offer_letter.pdf`);
// //             formDataToSend.append("candidateName", formData.candidateName);

// //             console.log("Sending PDF to backend...");
// //             const response = await axios.post( /* ... */
// //                  "https://raasbackend.vetrinahealthcare.com/save_pdf/",
// //                 formDataToSend,
// //                 { headers: { "Content-Type": "multipart/form-data" } }
// //             );

// //             Swal.close();
// //             console.log("Backend response:", response.data);
// //             Swal.fire({ /* ... success message ... */
// //                  icon: "success",
// //                 title: "Offer Letter PDF Saved!",
// //                 text: response.data.message || "The generated PDF has been saved.",
// //                 timer: 2500,
// //                 timerProgressBar: true,
// //                 showConfirmButton: false,
// //             }).then(() => {
// //                 navigate("/letterform");
// //             });

// //         } catch (error) {
// //              // ... (error handling remains the same) ...
// //             Swal.close();
// //             console.error("Error during PDF generation or saving:", error);
// //              if (error.response) {
// //                 console.error("Backend Error Response:", error.response.data);
// //                 console.error("Backend Error Status:", error.response.status);
// //             } else if (error.request) {
// //                 console.error("Backend No Response:", error.request);
// //             } else {
// //                 console.error("PDF Generation/Setup Error:", error.message);
// //             }
// //             const errorText = error.response?.data?.error || error.message || "An unexpected error occurred.";
// //             Swal.fire("PDF Generation Failed", `Error: ${errorText}`, "error");
// //         }
// //     };

// //     // --- Prepare Data for Rendering (Keep as before) ---
// //     const safeData = {
// //         // ... (safeData remains the same) ...
// //         candidateName: formData.candidateName || "Candidate Name",
// //         position: formData.position || "Position",
// //         salary: formData.salary || "N/A",
// //         date: formatDate(formData.date),
// //         address: formData.address || "[Address]",
// //         pinCode: formData.pinCode || "[Pin Code]",
// //         mobileNumber: formData.mobileNumber || "[Mobile Number]",
// //         reportingTo: formData.reportingTo || "[Reporting Manager]",
// //         basedHQ: formData.basedHQ || "[Base HQ]",
// //         hrName: formData.hr?.name || "HR Manager",
// //         hrTitle: "HR Manager",
// //     };

// //     // --- Conditional Rendering Check (Keep as before) ---
// //     if (!formData || !formData.candidateName) {
// //         // ... (loading/redirecting code) ...
// //          return ( /* ... loading indicator ... */
// //              <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
// //                 <DashNavbar />
// //                 <div style={{ display: "flex", flex: 1 }}>
// //                     <Sidebar />
// //                     <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
// //                         <p>Loading data or redirecting...</p>
// //                     </div>
// //                 </div>
// //             </div>
// //          );
// //     }

// //     // --- Render the Offer Letter ---
// //     return (
// //         <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
// //             <DashNavbar />
// //             <div style={{ display: "flex", flexGrow: 1 }}>
// //                 <Sidebar />
// //                 <div style={{ /* ... outer container styles ... */
// //                     flexGrow: 1,
// //                     backgroundColor: "#e0e0e0",
// //                     padding: "30px 20px",
// //                     overflowY: 'auto',
// //                     display: 'flex',
// //                     justifyContent: 'center',
// //                     alignItems: 'flex-start'
// //                 }}>
// //                     <div style={{ width: '595px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

// //                         {/* Container Ref */}
// //                         <div ref={offerLetterRef} style={{
// //                             width: "595px",
// //                             margin: 0,
// //                             padding: 0,
// //                             backgroundColor: '#fff',
// //                             lineHeight: 0,
// //                             fontSize: 0,
// //                             display: 'block',
// //                         }}>

// //                             {/* --- Page 1 DIV --- */}
// //                             <div
// //                                 style={{
// //                                     width: "595px",
// //                                     height: "842px",
// //                                     backgroundColor: "#ffffff",
// //                                     position: "relative",
// //                                     overflow: "hidden",
// //                                     pageBreakAfter: "always", // Still the primary break indicator
// //                                     fontFamily: "'Arial', sans-serif",
// //                                     fontSize: "10px",
// //                                     color: "black",
// //                                     lineHeight: "1.3",
// //                                     boxSizing: "border-box",
// //                                     margin: 0,
// //                                     padding: 0,
// //                                     display: 'block',
// //                                 }}
// //                             >
// //                                 {/* Background Image 1 */}
// //                                 <img /* ... */
// //                                     src={offerLetterBackgroundImage}
// //                                     alt="Offer Letter Background Page 1"
// //                                     style={{
// //                                         position: 'absolute', top: 0, left: 0, width: '100%',
// //                                         height: '100%', objectFit: 'cover', zIndex: 1
// //                                     }}
// //                                 />
// //                                 {/* Content 1 */}
// //                                 {/* ... (All content divs remain exactly the same) ... */}
// //                                 <div style={{ position: "absolute", top: "100px", left: "68px", zIndex: 2 }}>To,</div>
// //                                 <div style={{ position: "absolute", top: "117px", left: "68px", fontWeight: "bold", zIndex: 2 }}>{safeData.candidateName}</div>
// //                                 <div style={{ position: "absolute", top: "132px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}>Address - {safeData.address}</div>
// //                                 <div style={{ position: "absolute", top: "143px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}>Pin code - {safeData.pinCode}</div>
// //                                 <div style={{ position: "absolute", top: "155px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}>Mobile No.: {safeData.mobileNumber}</div>
// //                                 <div style={{ position: "absolute", top: "83px", right: "60px", width: "150px", textAlign: "right", zIndex: 2 }}>Date - {safeData.date}</div>
// //                                 <div style={{ position: "absolute", top: "200px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}><u>Subject: - Offer letter for the position of {safeData.position}.</u></div>
// //                                 <div style={{ position: "absolute", top: "240px", left: "68px", textAlign: "left", zIndex: 2 }}>Dear Mr./Ms. {safeData.candidateName.split(' ')[0]},</div>
// //                                 <div style={{ position: "absolute", top: "280px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>Based on our discussion in your interview we would like to offer you the position of <strong>{safeData.position} at VETRINA HEALTHCARE PVT. LTD.</strong> You will report to {safeData.reportingTo} who will define your roles and responsibility.</div>
// //                                 <div style={{ position: "absolute", top: "320px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>Your annual CTC will be INR <strong>{safeData.salary} /- LAKH PER ANNUM.</strong> We will increase your salary, after analyzing your performance.</div>
// //                                 <div style={{ position: "absolute", top: "360px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>Initially you will be based at <strong>HQ {safeData.basedHQ}.</strong> You will be responsible for the development of company business of Vetrina Healthcare Pvt. Ltd. You are liable to be transferred from time to time to other places as may be notified to you by company.</div>
// //                                 <div style={{ position: "absolute", top: "410px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>The company might pay variable bonus and incentives. This will be dependent on your performance in company in specific time frame. The decision to grant a bonus and the manner in which it will be calculated is at the sole discretion of the company and is not negotiable.</div>
// //                                 <div style={{ position: "absolute", top: "470px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>You will be required to abide by the rules and regulations of <strong>VETRINA HEALTHCARE PVT. LTD</strong>, that may be in force at the time of your appointment and also that may be promulgated from time to time thereafter.</div>
// //                                 <div style={{ position: "absolute", top: "540px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>If you have any question or concerns, please feel free to contact us.</div>
// //                                 <div style={{ position: "absolute", top: "590px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}>Thanks & Regards</div>
// //                                 <div style={{ position: "absolute", top: "580px", left: "140px", width: "100px", height: "100px", zIndex: 3 }}>
// //                                     <img src={VetrinaStamp} alt="Vetrina Stamp" style={{ maxWidth: "120%", maxHeight: "120%" }} />
// //                                 </div>
// //                                 <div style={{ position: "absolute", top: "670px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}>
// //                                     Mr / Mrs. {safeData.hrName} <br />
// //                                     {safeData.hrTitle}<br />
// //                                     Vetrina Healthcare Pvt. Ltd.
// //                                 </div>
// //                             </div>{/* End Page 1 */}
// //                             {/* Start Page 2 */}
// //                             <div
// //                                 id="page-2"
// //                                 style={{
// //                                     width: "595px",
// //                                     height: "842px",
// //                                     backgroundColor: "#ffffff",
// //                                     position: "relative", // Keep relative for potential internal absolute positioning
// //                                     overflow: "hidden",
// //                                     boxSizing: "border-box",
// //                                     padding: 0,
// //                                     display: 'block',
// //                                     // *** Key Change: Add small negative top margin ***
// //                                     marginTop: "-1px",
// //                                     // Also ensure no positive margin exists
// //                                     marginBottom: 0,
// //                                     marginLeft: 0,
// //                                     marginRight: 0,
// //                                 }}
// //                             >
// //                                 {/* Background Image 2 */}
// //                                 <img
// //                                     src={offerLetterBackgroundImage2}
// //                                     alt="Offer Letter Background Page 2"
// //                                     style={{
// //                                         position: 'absolute', top: 0, left: 0, width: '100%',
// //                                         height: '100%', objectFit: 'cover', zIndex: 1
// //                                     }}
// //                                 />
// //                                 {/* Content 2 (if any) */}
// //                                 {/* ... */}
// //                             </div>{/* End Page 2 */}

// //                         </div> {/* End Ref Container */}

// //                         {/* Save Button Area */}
// //                         <div style={{ width: '100%', textAlign: 'center', marginTop: '30px', marginBottom: '30px' }}>
// //                             <Button onClick={downloadAsPDF} variant="primary" size="lg">
// //                                 <i className="fas fa-save me-2"></i> Save Final PDF
// //                             </Button>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // export default OfferLetter;

// // OfferLetter.js
// import React, { useRef, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { Button } from "react-bootstrap";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import { useLocation, useNavigate } from "react-router-dom";
// import offerLetterBackgroundImage from "../../Assets/Vetrina Offer Letter-1.png";
// import offerLetterBackgroundImage2 from "../../Assets/Vetrina Offer Letter-2.png";
// import html2pdf from "html2pdf.js";
// import axios from "axios";
// import Swal from "sweetalert2";
// import VetrinaStamp from "../../Assets/VetrinaStamp.png";

// // --- Helper Functions ---
// const formatDate = (date) => {
//     if (!date) return "";
//     try {
//         // Handle cases where date might already be formatted DD/MM/YYYY
//         if (typeof date === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
//             return date;
//         }
//         const d = new Date(date);
//         if (isNaN(d.getTime())) {
//             // Try parsing ISO string if direct parsing fails
//             const isoDate = new Date(Date.parse(date));
//             if (isNaN(isoDate.getTime())) {
//                 console.warn("Invalid date received:", date);
//                 return "Invalid Date";
//             }
//             const day = String(isoDate.getDate()).padStart(2, "0");
//             const month = String(isoDate.getMonth() + 1).padStart(2, "0");
//             const year = isoDate.getFullYear();
//             return `${day}/${month}/${year}`;
//         }
//         const day = String(d.getDate()).padStart(2, "0");
//         const month = String(d.getMonth() + 1).padStart(2, "0");
//         const year = d.getFullYear();
//         return `${day}/${month}/${year}`;
//     } catch (e) {
//         console.error("Error formatting date:", date, e);
//         return "Error Date";
//     }
// };


// const OfferLetter = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const formData = location.state || {}; // Get data passed via navigate state
//     const offerLetterRef = useRef(null);

//     // Log received state for debugging
//     useEffect(() => {
//         console.log("OfferLetter received state:", formData);
//     }, [formData]);

//     // --- Data Validation Effect ---
//     useEffect(() => {
//         let isDataMissing = false;
//         let missingFields = [];

//         if (!formData || !formData.candidateName) {
//             isDataMissing = true;
//             missingFields.push('candidateName');
//         }
//         if (!formData.date) {
//             isDataMissing = true;
//             missingFields.push('date');
//         }
//         // HR is required for both template and custom offer letters for signature
//         if (!formData.hr?.name) {
//             isDataMissing = true;
//             missingFields.push('hr');
//         }

//         // Template specific checks
//         if (formData.generationMethod === 'template') {
//             const templateRequiredFields = ['position', 'salary', 'address', 'pinCode', 'mobileNumber']; // Removed hr from here as it's checked above
//             templateRequiredFields.forEach(field => {
//                 if (!formData[field]) {
//                     isDataMissing = true;
//                     if (!missingFields.includes(field)) missingFields.push(field);
//                 }
//             });
//         }
//         // Custom specific checks
//         else if (formData.generationMethod === 'custom') {
//             if (!formData.customContent) {
//                 isDataMissing = true;
//                 if (!missingFields.includes('customContent')) missingFields.push('customContent');
//             }
//         } else if (formData.generationMethod !== 'template' && formData.generationMethod !== 'custom') {
//             // If generationMethod is missing or unexpected
//             isDataMissing = true;
//             missingFields.push('generationMethod');
//         }


//         const isIncorrectSection = formData.section !== 'Offer Letter'; // This component is only for Offer Letters

//         if (isDataMissing || isIncorrectSection) {
//             console.error("OfferLetter: Missing required data or incorrect letter type.", { formData, missingFields, isIncorrectSection });
//             Swal.fire({
//                 icon: "error",
//                 title: "Missing or Invalid Data",
//                 text: `Could not load required offer letter data (${missingFields.join(', ')}) or incorrect type specified. Redirecting back.`,
//                 confirmButtonText: "OK"
//             }).then(() => {
//                 navigate("/letterform"); // Navigate back to the list/form page
//             });
//         }
//     }, [formData, navigate]);

//     // --- PDF Generation Function ---
//     const downloadAsPDF = async () => {
//         const elementToCapture = offerLetterRef.current;

//         if (!elementToCapture) {
//             Swal.fire("Error", "Cannot generate PDF. Letter element not found.", "error");
//             return;
//         }
//         if (!formData || !formData.candidateName) {
//             Swal.fire("Error", "Cannot generate PDF. Missing candidate data.", "error");
//             return;
//         }

//         // Temporarily hide the button before capturing PDF
//         const buttonElement = document.getElementById('save-pdf-button-container');
//         if (buttonElement) buttonElement.style.display = 'none';


//         Swal.fire({
//             title: 'Generating PDF...',
//             text: 'Please wait while the offer letter is being generated.',
//             allowOutsideClick: false,
//             didOpen: () => { Swal.showLoading(); }
//         });

//         const opt = {
//             margin: 0,
//             filename: `${formData.candidateName}_offer_letter.pdf`,
//             image: { type: "jpeg", quality: 0.98 },
//             html2canvas: {
//                 scale: 2,
//                 useCORS: true,
//                 logging: true,
//                 width: 595,
//                 scrollX: 0,
//                 scrollY: 0,
//                 windowWidth: 595,
//             },
//             jsPDF: {
//                 unit: "px",
//                 format: [595, 842],
//                 orientation: "portrait",
//             },
//         };

//         try {
//             console.log("Capturing element:", elementToCapture);
//             console.log("Using options:", opt);
//             await new Promise(resolve => setTimeout(resolve, 100)); // Short delay

//             const pdfBlob = await html2pdf()
//                 .from(elementToCapture)
//                 .set(opt)
//                 .output('blob');

//             console.log("PDF Blob created, size:", pdfBlob.size);

//             const formDataToSend = new FormData();
//             formDataToSend.append("pdf", pdfBlob, `${formData.candidateName}_offer_letter.pdf`);
//             formDataToSend.append("candidateName", formData.candidateName);
//             if (formData.user_id) { // Send user_id if available
//                 formDataToSend.append("user_id", formData.user_id);
//             }

//             console.log("Sending PDF to backend...");
//             const response = await axios.post(
//                 "https://raasbackend.vetrinahealthcare.com/save_pdf/",
//                 formDataToSend,
//                 { headers: { "Content-Type": "multipart/form-data" } }
//             );

//             Swal.close();
//             // Show the button again after PDF generation attempt
//             if (buttonElement) buttonElement.style.display = 'block';
//             console.log("Backend response:", response.data);
//             Swal.fire({
//                 icon: "success",
//                 title: "Offer Letter PDF Saved!",
//                 text: response.data.message || "The generated PDF has been saved.",
//                 timer: 2500,
//                 timerProgressBar: true,
//                 showConfirmButton: false,
//             }).then(() => {
//                 navigate("/letterform");
//             });

//         } catch (error) {
//             // Show the button again even if there's an error
//             if (buttonElement) buttonElement.style.display = 'block';
//             Swal.close();
//             console.error("Error during PDF generation or saving:", error);
//             if (error.response) {
//                 console.error("Backend Error Response:", error.response.data);
//                 console.error("Backend Error Status:", error.response.status);
//             } else if (error.request) {
//                 console.error("Backend No Response:", error.request);
//             } else {
//                 console.error("PDF Generation/Setup Error:", error.message);
//                 console.error(error);
//             }
//             const errorText = error.response?.data?.error || error.message || "An unexpected error occurred.";
//             Swal.fire("PDF Generation Failed", `Error: ${errorText}`, "error");
//         }
//     };

//     // --- Prepare Data for Rendering ---
//     const safeData = {
//         // Common fields
//         candidateName: formData.candidateName || "Candidate Name",
//         date: formatDate(formData.date),
//         address: formData.address || "[Address]",
//         pinCode: formData.pinCode || "[Pin Code]",
//         mobileNumber: formData.mobileNumber || "[Mobile Number]",
//         hrName: formData.hr?.name || "[HR Manager Name]", // Needed for signature block always
//         hrTitle: "HR Manager", // Assuming title is constant or fetch if available

//         // Template specific (will be null/undefined if generationMethod is 'custom')
//         position: formData.position || "[Position]",
//         salary: formData.salary || "[N/A]",
//         reportingTo: formData.reportingTo || "[Reporting Manager]",
//         basedHQ: formData.basedHQ || "[Base HQ]",

//         // Custom specific
//         customContent: formData.customContent || "",

//         // Meta
//         // Meta
//         generationMethod: formData.generationMethod, // Crucial for conditional rendering
//         signaturePreviewUrl: formData.signaturePreviewUrl || null, // *** ADDED: Get signature URL from state ***
//     };

//     // --- Conditional Rendering Check ---
//     if (!formData || !formData.candidateName || !formData.generationMethod || !formData.hr?.name) { // Added HR check here too
//         return (
//             <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
//                 <DashNavbar />
//                 <div style={{ display: "flex", flex: 1 }}>
//                     <Sidebar />
//                     <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
//                         <p>Loading data or redirecting...</p>
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     // --- Render the Offer Letter ---
//     return (
//         <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//             <DashNavbar />
//             <div style={{ display: "flex", flexGrow: 1 }}>
//                 <Sidebar />
//                 {/* --- Main Content Area --- */}
//                 <div style={{
//                     flexGrow: 1,
//                     backgroundColor: "#e0e0e0",
//                     padding: "30px 20px", // Keep padding
//                     overflowY: 'auto',
//                     display: 'flex', // Keep flex for centering letter preview
//                     justifyContent: 'center', // Keep centering letter preview
//                     alignItems: 'flex-start', // Keep align start
//                     position: 'relative' // *** Added for absolute positioning of children ***
//                 }}>

//                     {/* --- Save Button Area (Moved Here & Styled) --- */}
//                     <div
//                         id="save-pdf-button-container" // Added ID to hide/show during generation
//                         style={{
//                             position: 'absolute',
//                             top: '25px', // Adjust spacing from top
//                             right: '25px', // Adjust spacing from right
//                             zIndex: 10 // Ensure it's above other content
//                         }}
//                     >
//                         <Button onClick={downloadAsPDF} variant="primary" size="lg">
//                             <i className="fas fa-save me-2"></i> Save Final PDF
//                         </Button>
//                     </div>

//                     {/* --- Letter Preview Container (Centered by parent flexbox) --- */}
//                     <div style={{ width: '595px', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '10px' /* Optional: Add some top margin if button crowds it */ }}>

//                         {/* --- Container Ref for PDF Generation --- */}
//                         <div ref={offerLetterRef} style={{
//                             width: "595px",
//                             margin: 0,
//                             padding: 0,
//                             backgroundColor: '#fff',
//                             lineHeight: 0,
//                             fontSize: 0,
//                             display: 'block',
//                         }}>

//                             {/* --- Page 1 DIV --- */}
//                             <div
//                                 style={{
//                                     width: "595px",
//                                     height: "842px",
//                                     backgroundColor: "#ffffff",
//                                     position: "relative",
//                                     overflow: "hidden",
//                                     fontFamily: "'Arial', sans-serif",
//                                     fontSize: "10px",
//                                     color: "black",
//                                     lineHeight: "1.3",
//                                     boxSizing: "border-box",
//                                     margin: 0,
//                                     padding: 0,
//                                     display: 'block',
//                                 }}
//                             >
//                                 {/* Background Image for Page 1 */}
//                                 <img
//                                     src={offerLetterBackgroundImage}
//                                     alt="Offer Letter Background Page 1"
//                                     style={{
//                                         position: 'absolute', top: 0, left: 0, width: '100%',
//                                         height: '100%', objectFit: 'cover', zIndex: 1
//                                     }}
//                                 />

//                                 {/* --- Common Content (Always Visible) --- */}
//                                 <div style={{ position: "absolute", top: "100px", left: "68px", zIndex: 2, fontSize: "10px" }}>To,</div>
//                                 <div style={{ position: "absolute", top: "115px", left: "68px", fontWeight: "bold", zIndex: 2, fontSize: "10px" }}>{safeData.candidateName},</div>
//                                 <div style={{ position: "absolute", top: "128px", left: "68px", width: "475px", textAlign: "left", zIndex: 2, fontSize: "10px" }}>Address - {safeData.address}</div>
//                                 <div style={{ position: "absolute", top: "141px", left: "68px", width: "475px", textAlign: "left", zIndex: 2, fontSize: "10px" }}>Pin code - {safeData.pinCode}</div>
//                                 <div style={{ position: "absolute", top: "155px", left: "68px", width: "475px", textAlign: "left", zIndex: 2, fontSize: "10px" }}>Mobile No.: {safeData.mobileNumber}</div>
//                                 <div style={{ position: "absolute", top: "83px", right: "60px", width: "150px", textAlign: "right", zIndex: 2, fontSize: "10px" }}>Date - {safeData.date}</div>

//                                 {/* --- Conditional Content Area --- */}
//                                 {safeData.generationMethod === 'template' ? (
//                                     <>
//                                         {/* --- Content for TEMPLATE Generation --- */}
//                                         <div style={{ position: "absolute", top: "200px", left: "68px", width: "475px", textAlign: "left", zIndex: 2, fontSize: "10px" }}><u>Subject: - Offer letter for the position of {safeData.position}.</u></div>
//                                         <div style={{ position: "absolute", top: "240px", left: "68px", textAlign: "left", zIndex: 2, fontSize: "10px" }}>Dear Mr./Ms. {safeData.candidateName.split(' ')[0]},</div>
//                                         <div style={{ position: "absolute", top: "280px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Based on our discussion in your interview we would like to offer you the position of <strong>{safeData.position} at VETRINA HEALTHCARE PVT. LTD.</strong> You will report to {safeData.reportingTo || '[Reporting Manager Name]'} who will define your roles and responsibility.</div>
//                                         <div style={{ position: "absolute", top: "320px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Your annual CTC will be INR <strong>{safeData.salary} /- LAKH PER ANNUM.</strong> We will increase your salary, after analyzing your performance.</div>
//                                         <div style={{ position: "absolute", top: "360px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Initially you will be based at <strong>HQ {safeData.basedHQ || '[Base HQ Name]'}.</strong> You will be responsible for the development of company business of Vetrina Healthcare Pvt. Ltd. You are liable to be transferred from time to time to other places as may be notified to you by company.</div>
//                                         <div style={{ position: "absolute", top: "410px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2, fontSize: "10px" }}>The company might pay variable bonus and incentives. This will be dependent on your performance in company in specific time frame. The decision to grant a bonus and the manner in which it will be calculated is at the sole discretion of the company and is not negotiable.</div>
//                                         <div style={{ position: "absolute", top: "470px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2, fontSize: "10px" }}>You will be required to abide by the rules and regulations of <strong>VETRINA HEALTHCARE PVT. LTD</strong>, that may be in force at the time of your appointment and also that may be promulgated from time to time thereafter.</div>
//                                     </>
//                                 ) : ( /* generationMethod === 'custom' */
//                                     <>
//                                         {/* --- Content for CUSTOM Generation --- */}
//                                         <div style={{
//                                             position: "absolute",
//                                             top: "200px",
//                                             left: "68px",
//                                             width: "475px",
//                                             zIndex: 2,
//                                             fontSize: "10px",
//                                             lineHeight: "1.4",
//                                             textAlign: "justify",
//                                             whiteSpace: "pre-wrap",
//                                             overflowWrap: "break-word",
//                                             maxHeight: "400px", // Adjust if needed
//                                             overflowY: "hidden"
//                                         }}>
//                                             {safeData.customContent}
//                                         </div>
//                                     </>
//                                 )}

//                                 {/* --- Common Footer Content (Always Visible) --- */}
//                                 <div style={{ position: "absolute", top: "540px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2, fontSize: "10px" }}>If you have any question or concerns, please feel free to contact us.</div>
//                                 <div style={{ position: "absolute", top: "590px", left: "68px", width: "475px", textAlign: "left", zIndex: 2, fontSize: "10px" }}>Thanks & Regards</div>
//                                 <div style={{ position: "absolute", top: "580px", left: "140px", width: "100px", height: "100px", zIndex: 3 }}>
//                                     <img src={VetrinaStamp} alt="Vetrina Stamp" style={{ maxWidth: "120%", maxHeight: "120%" }} />
//                                 </div>
//                                 <div style={{ position: "absolute", top: "670px", left: "68px", width: "475px", textAlign: "left", zIndex: 2, fontSize: "10px" }}>
//                                     Mr / Mrs. {safeData.hrName} <br />
//                                     {safeData.hrTitle}<br />
//                                     Vetrina Healthcare Pvt. Ltd.
//                                 </div>

//                                 {/* *** ADDED: Signature Image Preview *** */}
//                                 {safeData.signaturePreviewUrl && (
//                                     <div style={{
//                                         position: "absolute",
//                                         // Adjust top/left for desired position near HR name, beside stamp
//                                         top: "610px", // Align top roughly above HR name
//                                         left: "68px",  // Align left with HR name block
//                                         width: "100px", // Adjust width as needed
//                                         height: "50px", // Adjust height as needed
//                                         zIndex: 3,      // Ensure it's above background
//                                         //border: '1px dashed red', // Optional: for positioning debug
//                                     }}>
//                                         <img
//                                             src={safeData.signaturePreviewUrl}
//                                             alt="Signature Preview"
//                                             style={{
//                                                 maxWidth: "100%",
//                                                 maxHeight: "100%",
//                                                  "contain" // Scale image within bounds
//                                             }}
//                                         />
//                                     </div>
//                                 )}
//                                 {/* ************************************ */}

//                             </div>{/* --- > Page 1 Div ENDS HERE <--- */}{/* --- > Page 2 Div STARTS HERE (NO WHITESPACE BETWEEN) <--- */}
//                             <div
//                                 id="page-2"
//                                 style={{
//                                     width: "595px",
//                                     height: "842px",
//                                     backgroundColor: "#ffffff",
//                                     position: "relative",
//                                     overflow: "hidden",
//                                     boxSizing: "border-box",
//                                     margin: 0,
//                                     padding: 0,
//                                     display: 'block',
//                                 }}
//                             >
//                                 {/* Background Image for Page 2 */}
//                                 <img
//                                     src={offerLetterBackgroundImage2}
//                                     alt="Offer Letter Background Page 2"
//                                     style={{
//                                         position: 'absolute', top: 0, left: 0, width: '100%',
//                                         height: '100%', objectFit: 'cover', zIndex: 1
//                                     }}
//                                 />
//                                 {/* --- Content for Page 2 --- */}
//                             </div>{/* --- > Page 2 Div ENDS HERE <--- */}

//                         </div> {/* --- End Ref Container --- */}

//                     </div> {/* --- End Letter Preview Container --- */}

//                 </div> {/* --- End Main Content Area --- */}
//             </div> {/* End flex row with Sidebar */}
//         </div> /* End outer container */
//     );
// };

// export default OfferLetter;

// // OfferLetter.js
// import React, { useRef, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { Button } from "react-bootstrap";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import { useLocation, useNavigate } from "react-router-dom";
// import offerLetterBackgroundImage from "../../Assets/Vetrina Offer Letter-1.png";
// import offerLetterBackgroundImage2 from "../../Assets/Vetrina Offer Letter-2.png";
// import html2pdf from "html2pdf.js";
// import axios from "axios";
// import Swal from "sweetalert2";
// import VetrinaStamp from "../../Assets/VetrinaStamp.png";

// // --- Helper Functions (Keep as before) ---
// const formatDate = (date) => {
//     // ... (formatDate function) ...
//     if (!date) return "";
//     try {
//         const d = new Date(date);
//         if (isNaN(d.getTime())) {
//             console.warn("Invalid date received:", date);
//             return "Invalid Date";
//         }
//         const day = String(d.getDate()).padStart(2, "0");
//         const month = String(d.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
//         const year = d.getFullYear();
//         return `${day}/${month}/${year}`;
//     } catch (e) {
//         console.error("Error formatting date:", date, e);
//         return "Error Date";
//     }
// };

// const OfferLetter = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const formData = location.state || {};
//     const offerLetterRef = useRef(null);

//     // --- Data Validation Effect (Keep as before) ---
//     useEffect(() => {
//         // ... (validation logic) ...
//         const requiredFields = ['candidateName', 'position', 'salary', 'date', 'hr', 'address', 'pinCode', 'mobileNumber'];
//         const isDataMissing = !formData || requiredFields.some(field => !formData[field]);
//         const isIncorrectSection = formData.section !== 'Offer Letter';

//         if (isDataMissing || isIncorrectSection) {
//             console.error("OfferLetter: Missing required data or incorrect letter type.", { formData });
//             Swal.fire({
//                 icon: "error",
//                 title: "Missing or Invalid Data",
//                 text: "Could not load all required offer letter data or incorrect type specified. Redirecting back.",
//                 confirmButtonText: "OK"
//             }).then(() => {
//                 navigate("/letterform");
//             });
//         }
//     }, [formData, navigate]);

//     // --- PDF Generation Function (Trying Legacy Mode + Negative Margin) ---
//     const downloadAsPDF = async () => {
//         const elementToCapture = offerLetterRef.current;

//         if (!elementToCapture) {
//             Swal.fire("Error", "Cannot generate PDF. Letter element not found.", "error");
//             return;
//         }
//         // ... (other checks) ...
//         if (!formData || !formData.candidateName) {
//             Swal.fire("Error", "Cannot generate PDF. Missing candidate data.", "error");
//             return;
//         }


//         Swal.fire({
//             title: 'Generating PDF...',
//             text: 'Please wait while the offer letter is being generated.',
//             allowOutsideClick: false,
//             didOpen: () => { Swal.showLoading(); }
//         });

//         // --- html2pdf.js Options (Trying Legacy Mode) ---
//         const opt = {
//             margin: 0,
//             filename: `${formData.candidateName}_offer_letter.pdf`,
//             image: { type: "jpeg", quality: 0.98 },
//             html2canvas: {
//                 scale: 2,
//                 useCORS: true,
//                 logging: true,
//                 width: 595,
//                 scrollX: 0,
//                 scrollY: 0,
//                 // Maybe explicitly tell it the full height it needs to capture?
//                 // windowHeight: elementToCapture.scrollHeight // or 842 * 2 = 1684
//             },
//             jsPDF: {
//                 unit: "px",
//                 format: [595, 842],
//                 orientation: "portrait",
//             },
//             // *** Key Change: Switch to 'legacy' mode ***
//             // This uses a different internal algorithm for page breaks
//             pagebreak: {
//                  mode: 'legacy',
//                  // We still rely on the CSS page-break-after on the first div
//             }
//         };

//         try {
//             console.log("Capturing element:", elementToCapture);
//             console.log("Using options:", opt);

//             const pdfBlob = await html2pdf()
//                 .from(elementToCapture)
//                 .set(opt)
//                 .output('blob');

//             console.log("PDF Blob created, size:", pdfBlob.size);

//             // --- Optional Debug Download Link ---
//             // const url = URL.createObjectURL(pdfBlob);
//             // const a = document.createElement("a");
//             // a.href = url;
//             // a.download = `${formData.candidateName}_offer_letter_DEBUG_LEGACY_MODE.pdf`;
//             // document.body.appendChild(a);
//             // a.click();
//             // document.body.removeChild(a);
//             // URL.revokeObjectURL(url);
//             // console.log("Debug download link triggered and removed.");
//             // --- End Debug ---


//             // --- Prepare FormData and Send to Backend (Keep as before) ---
//             const formDataToSend = new FormData();
//             // ... (append data) ...
//             formDataToSend.append("pdf", pdfBlob, `${formData.candidateName}_offer_letter.pdf`);
//             formDataToSend.append("candidateName", formData.candidateName);

//             console.log("Sending PDF to backend...");
//             const response = await axios.post( /* ... */
//                  "https://raasbackend.vetrinahealthcare.com/save_pdf/",
//                 formDataToSend,
//                 { headers: { "Content-Type": "multipart/form-data" } }
//             );

//             Swal.close();
//             console.log("Backend response:", response.data);
//             Swal.fire({ /* ... success message ... */
//                  icon: "success",
//                 title: "Offer Letter PDF Saved!",
//                 text: response.data.message || "The generated PDF has been saved.",
//                 timer: 2500,
//                 timerProgressBar: true,
//                 showConfirmButton: false,
//             }).then(() => {
//                 navigate("/letterform");
//             });

//         } catch (error) {
//              // ... (error handling remains the same) ...
//             Swal.close();
//             console.error("Error during PDF generation or saving:", error);
//              if (error.response) {
//                 console.error("Backend Error Response:", error.response.data);
//                 console.error("Backend Error Status:", error.response.status);
//             } else if (error.request) {
//                 console.error("Backend No Response:", error.request);
//             } else {
//                 console.error("PDF Generation/Setup Error:", error.message);
//             }
//             const errorText = error.response?.data?.error || error.message || "An unexpected error occurred.";
//             Swal.fire("PDF Generation Failed", `Error: ${errorText}`, "error");
//         }
//     };

//     // --- Prepare Data for Rendering (Keep as before) ---
//     const safeData = {
//         // ... (safeData remains the same) ...
//         candidateName: formData.candidateName || "Candidate Name",
//         position: formData.position || "Position",
//         salary: formData.salary || "N/A",
//         date: formatDate(formData.date),
//         address: formData.address || "[Address]",
//         pinCode: formData.pinCode || "[Pin Code]",
//         mobileNumber: formData.mobileNumber || "[Mobile Number]",
//         reportingTo: formData.reportingTo || "[Reporting Manager]",
//         basedHQ: formData.basedHQ || "[Base HQ]",
//         hrName: formData.hr?.name || "HR Manager",
//         hrTitle: "HR Manager",
//     };

//     // --- Conditional Rendering Check (Keep as before) ---
//     if (!formData || !formData.candidateName) {
//         // ... (loading/redirecting code) ...
//          return ( /* ... loading indicator ... */
//              <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
//                 <DashNavbar />
//                 <div style={{ display: "flex", flex: 1 }}>
//                     <Sidebar />
//                     <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
//                         <p>Loading data or redirecting...</p>
//                     </div>
//                 </div>
//             </div>
//          );
//     }

//     // --- Render the Offer Letter ---
//     return (
//         <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//             <DashNavbar />
//             <div style={{ display: "flex", flexGrow: 1 }}>
//                 <Sidebar />
//                 <div style={{ /* ... outer container styles ... */
//                     flexGrow: 1,
//                     backgroundColor: "#e0e0e0",
//                     padding: "30px 20px",
//                     overflowY: 'auto',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'flex-start'
//                 }}>
//                     <div style={{ width: '595px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

//                         {/* Container Ref */}
//                         <div ref={offerLetterRef} style={{
//                             width: "595px",
//                             margin: 0,
//                             padding: 0,
//                             backgroundColor: '#fff',
//                             lineHeight: 0,
//                             fontSize: 0,
//                             display: 'block',
//                         }}>

//                             {/* --- Page 1 DIV --- */}
//                             <div
//                                 style={{
//                                     width: "595px",
//                                     height: "842px",
//                                     backgroundColor: "#ffffff",
//                                     position: "relative",
//                                     overflow: "hidden",
//                                     pageBreakAfter: "always", // Still the primary break indicator
//                                     fontFamily: "'Arial', sans-serif",
//                                     fontSize: "10px",
//                                     color: "black",
//                                     lineHeight: "1.3",
//                                     boxSizing: "border-box",
//                                     margin: 0,
//                                     padding: 0,
//                                     display: 'block',
//                                 }}
//                             >
//                                 {/* Background Image 1 */}
//                                 <img /* ... */
//                                     src={offerLetterBackgroundImage}
//                                     alt="Offer Letter Background Page 1"
//                                     style={{
//                                         position: 'absolute', top: 0, left: 0, width: '100%',
//                                         height: '100%', objectFit: 'cover', zIndex: 1
//                                     }}
//                                 />
//                                 {/* Content 1 */}
//                                 {/* ... (All content divs remain exactly the same) ... */}
//                                 <div style={{ position: "absolute", top: "100px", left: "68px", zIndex: 2 }}>To,</div>
//                                 <div style={{ position: "absolute", top: "117px", left: "68px", fontWeight: "bold", zIndex: 2 }}>{safeData.candidateName}</div>
//                                 <div style={{ position: "absolute", top: "132px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}>Address - {safeData.address}</div>
//                                 <div style={{ position: "absolute", top: "143px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}>Pin code - {safeData.pinCode}</div>
//                                 <div style={{ position: "absolute", top: "155px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}>Mobile No.: {safeData.mobileNumber}</div>
//                                 <div style={{ position: "absolute", top: "83px", right: "60px", width: "150px", textAlign: "right", zIndex: 2 }}>Date - {safeData.date}</div>
//                                 <div style={{ position: "absolute", top: "200px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}><u>Subject: - Offer letter for the position of {safeData.position}.</u></div>
//                                 <div style={{ position: "absolute", top: "240px", left: "68px", textAlign: "left", zIndex: 2 }}>Dear Mr./Ms. {safeData.candidateName.split(' ')[0]},</div>
//                                 <div style={{ position: "absolute", top: "280px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>Based on our discussion in your interview we would like to offer you the position of <strong>{safeData.position} at VETRINA HEALTHCARE PVT. LTD.</strong> You will report to {safeData.reportingTo} who will define your roles and responsibility.</div>
//                                 <div style={{ position: "absolute", top: "320px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>Your annual CTC will be INR <strong>{safeData.salary} /- LAKH PER ANNUM.</strong> We will increase your salary, after analyzing your performance.</div>
//                                 <div style={{ position: "absolute", top: "360px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>Initially you will be based at <strong>HQ {safeData.basedHQ}.</strong> You will be responsible for the development of company business of Vetrina Healthcare Pvt. Ltd. You are liable to be transferred from time to time to other places as may be notified to you by company.</div>
//                                 <div style={{ position: "absolute", top: "410px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>The company might pay variable bonus and incentives. This will be dependent on your performance in company in specific time frame. The decision to grant a bonus and the manner in which it will be calculated is at the sole discretion of the company and is not negotiable.</div>
//                                 <div style={{ position: "absolute", top: "470px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>You will be required to abide by the rules and regulations of <strong>VETRINA HEALTHCARE PVT. LTD</strong>, that may be in force at the time of your appointment and also that may be promulgated from time to time thereafter.</div>
//                                 <div style={{ position: "absolute", top: "540px", left: "68px", width: "475px", textAlign: "justify", zIndex: 2 }}>If you have any question or concerns, please feel free to contact us.</div>
//                                 <div style={{ position: "absolute", top: "590px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}>Thanks & Regards</div>
//                                 <div style={{ position: "absolute", top: "580px", left: "140px", width: "100px", height: "100px", zIndex: 3 }}>
//                                     <img src={VetrinaStamp} alt="Vetrina Stamp" style={{ maxWidth: "120%", maxHeight: "120%" }} />
//                                 </div>
//                                 <div style={{ position: "absolute", top: "670px", left: "68px", width: "475px", textAlign: "left", zIndex: 2 }}>
//                                     Mr / Mrs. {safeData.hrName} <br />
//                                     {safeData.hrTitle}<br />
//                                     Vetrina Healthcare Pvt. Ltd.
//                                 </div>
//                             </div>{/* End Page 1 */}
//                             {/* Start Page 2 */}
//                             <div
//                                 id="page-2"
//                                 style={{
//                                     width: "595px",
//                                     height: "842px",
//                                     backgroundColor: "#ffffff",
//                                     position: "relative", // Keep relative for potential internal absolute positioning
//                                     overflow: "hidden",
//                                     boxSizing: "border-box",
//                                     padding: 0,
//                                     display: 'block',
//                                     // *** Key Change: Add small negative top margin ***
//                                     marginTop: "-1px",
//                                     // Also ensure no positive margin exists
//                                     marginBottom: 0,
//                                     marginLeft: 0,
//                                     marginRight: 0,
//                                 }}
//                             >
//                                 {/* Background Image 2 */}
//                                 <img
//                                     src={offerLetterBackgroundImage2}
//                                     alt="Offer Letter Background Page 2"
//                                     style={{
//                                         position: 'absolute', top: 0, left: 0, width: '100%',
//                                         height: '100%', objectFit: 'cover', zIndex: 1
//                                     }}
//                                 />
//                                 {/* Content 2 (if any) */}
//                                 {/* ... */}
//                             </div>{/* End Page 2 */}

//                         </div> {/* End Ref Container */}

//                         {/* Save Button Area */}
//                         <div style={{ width: '100%', textAlign: 'center', marginTop: '30px', marginBottom: '30px' }}>
//                             <Button onClick={downloadAsPDF} variant="primary" size="lg">
//                                 <i className="fas fa-save me-2"></i> Save Final PDF
//                             </Button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default OfferLetter;

// OfferLetter.js
// import React, { useRef, useEffect, useState, useMemo } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { Button, Spinner } from "react-bootstrap";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import { useLocation, useNavigate } from "react-router-dom";
// import offerLetterBackgroundImage from "../../Assets/Vetrina Offer Letter-1.png";
// // Removed offerLetterBackgroundImage2 as pagination handles background per page now
// import html2pdf from "html2pdf.js";
// import axios from "axios";
// import Swal from "sweetalert2";
// import VetrinaStamp from "../../Assets/VetrinaStamp.png";

// // =====================================================================
// // ===== MANUAL LAYOUT CONFIGURATION (From Modified Code) =============
// // =====================================================================
// const PAGE_WIDTH_PX = 595;
// const PAGE_HEIGHT_PX = 842;
// const HEADER_CONTENT_LEFT_PX = 68;
// const HEADER_CONTENT_RIGHT_MARGIN_PX = 60;
// const HEADER_CONTENT_TOP_PX = 83;
// const CONTENT_LEFT_PX = 68;
// const CONTENT_WIDTH_PX = 475;
// const CONTENT_TOP_PAGE_1_PX = 200; // Start content lower on page 1
// const CONTENT_TOP_SUBSEQUENT_PX = 110; // Start content higher on subsequent pages
// const CONTENT_BOTTOM_MARGIN_PX = 55; // Space before footer might start
// const FOOTER_TOP_PX = 640; // Where the footer block starts (relative to page top)
// const FOOTER_LEFT_PX = 68;
// const FOOTER_WIDTH_PX = 475;
// const STAMP_OFFSET_TOP_PX = -50; // Offset relative to FOOTER_TOP_PX (590px absolute)
// const STAMP_OFFSET_LEFT_PX = 72; // Offset relative to FOOTER_LEFT_PX (140px absolute)
// const STAMP_WIDTH_PX = 100;
// const STAMP_HEIGHT_PX = 100;
// const SIGNATURE_OFFSET_TOP_PX = -10; // Offset relative to FOOTER_TOP_PX (630px absolute)
// const SIGNATURE_OFFSET_LEFT_PX = 0; // Offset relative to FOOTER_LEFT_PX (68px absolute)
// const SIGNATURE_WIDTH_PX = 100;
// const SIGNATURE_HEIGHT_PX = 50;
// // =====================================================================
// // ===== DERIVED CALCULATIONS (From Modified Code) ====================
// // =====================================================================
// const MAX_CONTENT_FILL_HEIGHT_PAGE_1 = PAGE_HEIGHT_PX - CONTENT_TOP_PAGE_1_PX - CONTENT_BOTTOM_MARGIN_PX;
// const MAX_CONTENT_HEIGHT_SUBSEQUENT = FOOTER_TOP_PX - CONTENT_TOP_SUBSEQUENT_PX + 110; // Max content height on pages 2+ before hitting footer area
// // =====================================================================

// // --- Helper Functions ---
// const formatDate = (date) => { // Using robust version from modified code
//     if (!date) return "";
//     try {
//         if (typeof date === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
//             return date;
//         }
//         const d = new Date(date);
//         if (isNaN(d.getTime())) {
//             const isoDate = new Date(Date.parse(date));
//             if (isNaN(isoDate.getTime())) {
//                 console.warn("Invalid date:", date);
//                 return "Invalid Date";
//             }
//             const day = String(isoDate.getDate()).padStart(2, "0");
//             const month = String(isoDate.getMonth() + 1).padStart(2, "0");
//             const year = isoDate.getFullYear();
//             return `${day}/${month}/${year}`;
//         }
//         const day = String(d.getDate()).padStart(2, "0");
//         const month = String(d.getMonth() + 1).padStart(2, "0");
//         const year = d.getFullYear();
//         return `${day}/${month}/${year}`;
//     } catch (e) {
//         console.error("Date format error:", date, e);
//         return "Error Date";
//     }
// };

// const OfferLetter = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const formData = location.state || {};
//     const offerLetterRef = useRef(null);
//     const measureRef = useRef(null); // For custom content pagination measurement

//     const [renderedPagesData, setRenderedPagesData] = useState([]);
//     const [isCalculatingPages, setIsCalculatingPages] = useState(false);
//     const [isDataValid, setIsDataValid] = useState(false);

//     // Use memoized safeData for stability (From Modified Code)
//     const safeData = useMemo(() => ({
//         candidateName: formData.candidateName || "Candidate Name",
//         date: formatDate(formData.date),
//         address: formData.address || "[Address]",
//         pinCode: formData.pinCode || "[Pin Code]",
//         mobileNumber: formData.mobileNumber || "[Mobile Number]",
//         hrName: formData.hr?.name || "[HR Manager Name]",
//         hrTitle: "HR Manager", // Assuming constant title
//         position: formData.position || "[Position]", // Used by template
//         salary: formData.salary || "[N/A]",         // Used by template
//         reportingTo: formData.reporting_manager || "[Reporting Manager]", // Used by template
//         basedHQ: formData.headquarter || "[Base HQ]", // Used by template
//         customContent: formData.customContent || "",   // Used by custom
//         generationMethod: formData.generationMethod,
//         signaturePreviewUrl: formData.signaturePreviewUrl || null,
//         user_id: formData.user_id,
//     }), [formData]);

//     // --- Data Validation Effect (From Modified Code - More Robust) ---
//     useEffect(() => {
//         console.log("OfferLetter State:", formData);
//         let isDataMissing = false;
//         let missingFields = [];

//         // Basic checks (needed for both)
//         if (!safeData.candidateName || safeData.candidateName === "Candidate Name") { isDataMissing = true; missingFields.push('candidateName'); }
//         if (!safeData.date || safeData.date === "Invalid Date" || safeData.date === "Error Date") { isDataMissing = true; missingFields.push('date'); }
//         if (!safeData.hrName || safeData.hrName === "[HR Manager Name]") { isDataMissing = true; missingFields.push('hr'); }
//         // Signature is needed for footer
//         if (!safeData.signaturePreviewUrl) { isDataMissing = true; missingFields.push('signature'); }

//         // Template specific checks
//         if (safeData.generationMethod === 'template') {
//             const flds = ['position', 'salary', 'address', 'pinCode', 'mobileNumber', 'reportingTo', 'basedHQ']; // Add all template fields
//             flds.forEach(f => {
//                 const value = safeData[f];
//                 if (!value || (typeof value === 'string' && value.startsWith('[')) || value === "Candidate Name" || value === "[N/A]") { // Added more checks
//                     isDataMissing = true;
//                     if (!missingFields.includes(f)) missingFields.push(f);
//                 }
//             });
//         }
//         // Custom specific checks
//         else if (safeData.generationMethod === 'custom') {
//             if (!safeData.customContent) {
//                 isDataMissing = true;
//                 if (!missingFields.includes('customContent')) missingFields.push('customContent');
//             }
//              // Custom also needs address details for header
//             const headerFields = ['address', 'pinCode', 'mobileNumber'];
//             headerFields.forEach(f => {
//                 const value = safeData[f];
//                 if (!value || (typeof value === 'string' && value.startsWith('['))) {
//                      isDataMissing = true;
//                      if (!missingFields.includes(f)) missingFields.push(f);
//                 }
//             });
//         }
//         // Check if generationMethod itself is missing/invalid
//         else {
//             isDataMissing = true;
//             missingFields.push('generationMethod');
//         }

//         // Check section type (optional robustness check)
//         const isIncorrectSection = formData.section !== 'Offer Letter';
//         if (isIncorrectSection) {
//              console.error("Incorrect section type detected:", formData.section);
//              // Optionally add: isDataMissing = true; if (!missingFields.includes('section')) missingFields.push('section');
//         }

//         // Final check and action
//         if (isDataMissing) {
//             setIsDataValid(false);
//             console.error("Invalid Data:", { safeData, missingFields, isIncorrectSection });
//             // Show error only if critical data is missing
//             if (missingFields.length > 0) {
//                 Swal.fire({
//                     icon: "error",
//                     title: "Missing or Invalid Data",
//                     text: `Could not load required offer letter data (${missingFields.join(', ')}). Redirecting.`,
//                     confirmButtonText: "OK"
//                 }).then(() => { navigate("/letterform"); });
//             }
//         } else {
//             setIsDataValid(true); // All checks passed
//         }
//     }, [safeData, formData.section, navigate]); // Keep dependencies


//     // --- Page Calculation Effect (From Modified Code - Handles Custom Pagination) ---
//     useEffect(() => {
//         if (!isDataValid || !measureRef.current) return;

//         // Always start calculation if data is valid
//         setIsCalculatingPages(true);

//         if (safeData.generationMethod === 'custom' && safeData.customContent) {
//             // Use timeout to allow DOM updates before measurement
//             setTimeout(() => {
//                 if (!measureRef.current) {
//                     console.error("Measure ref disappeared during calculation.");
//                     setIsCalculatingPages(false);
//                     setRenderedPagesData([]); // Ensure no stale data
//                     return;
//                 }

//                 const calculatedPages = [];
//                 const contentLines = safeData.customContent.split('\n');
//                 let currentPageContent = "";
//                 const measureDiv = measureRef.current;
//                 measureDiv.style.width = `${CONTENT_WIDTH_PX}px`; // Set width for accurate height measurement
//                 measureDiv.innerHTML = ''; // Clear previous content

//                 contentLines.forEach((line, index) => {
//                     const contentWithNewLine = currentPageContent + (currentPageContent ? '\n' : '') + line;
//                     measureDiv.innerText = contentWithNewLine; // Use innerText for accurate line breaking measurement
//                     const estimatedHeight = measureDiv.scrollHeight; // Get calculated height

//                     const isFirstPage = calculatedPages.length === 0;
//                     const maxHeightForThisPage = isFirstPage ? MAX_CONTENT_FILL_HEIGHT_PAGE_1 : MAX_CONTENT_HEIGHT_SUBSEQUENT;

//                     // Check if adding the line exceeds the max height FOR THIS PAGE
//                     // Also ensure currentPageContent is not empty before splitting (prevents empty pages)
//                     if (estimatedHeight > maxHeightForThisPage && currentPageContent.trim()) {
//                         // Current page is full, push it
//                         calculatedPages.push(currentPageContent);
//                         // Start new page with the current line
//                         currentPageContent = line;
//                         // Measure the new line alone to reset height calculation for the new page
//                         measureDiv.innerText = line;
//                     } else {
//                         // Add line to current page content
//                          currentPageContent += (currentPageContent ? '\n' : '') + line;
//                     }
//                 });

//                 // Add the last page's content if it's not empty
//                 if (currentPageContent.trim()) {
//                     calculatedPages.push(currentPageContent);
//                 }

//                 setRenderedPagesData(calculatedPages); // Set the calculated pages
//                 setIsCalculatingPages(false);
//                 console.log(`Custom content calculation resulted in ${calculatedPages.length} pages.`);

//             }, 100); // Small delay for rendering updates

//         } else if (safeData.generationMethod === 'template') {
//              // Template currently assumed to fit on one page
//              setRenderedPagesData(['template_content_placeholder']); // Placeholder indicates one page for template
//              setIsCalculatingPages(false);
//              console.log("Using single page structure for template.");
//         } else {
//              // Should not happen if validation is correct, but handle defensively
//              setRenderedPagesData([]);
//              setIsCalculatingPages(false);
//              console.warn("No valid generation method for page calculation.");
//         }
//     // IMPORTANT: Dependencies ensure recalculation if custom content or method changes
//     }, [isDataValid, safeData.generationMethod, safeData.customContent]);


//     // --- PDF Generation Function (From Modified Code - Handles Multi-page) ---
//     const downloadAsPDF = async () => {
//         if (!offerLetterRef.current || !isDataValid || renderedPagesData.length === 0) {
//             Swal.fire("Error", "Cannot generate PDF. No content pages rendered or data is invalid.", "error");
//             return;
//         }
//         const elementToCapture = offerLetterRef.current;

//         // Extra check for essential data
//         if (!safeData.candidateName || safeData.candidateName === "Candidate Name" || !safeData.hrName || safeData.hrName === "[HR Manager Name]") {
//              Swal.fire("Error", "Cannot generate PDF. Missing candidate name or HR name.", "error");
//              return;
//         }

//         const btn = document.getElementById('save-pdf-button-container');
//         if (btn) btn.style.visibility = 'hidden'; // Hide button

//         Swal.fire({
//             title: 'Generating PDF...',
//             text: 'Please wait while the offer letter is being processed.',
//             allowOutsideClick: false,
//             didOpen: () => { Swal.showLoading(); }
//         });

//         const opt = {
//             margin: 0,
//             filename: `${safeData.candidateName}_offer_letter.pdf`,
//             image: { type: "jpeg", quality: 0.98 },
//             html2canvas: {
//                 scale: 2, // Good resolution
//                 useCORS: true, // Important for external images like signatures
//                 logging: false, // Reduce console noise
//                 scrollX: 0, // Ensure capture starts at top-left
//                 scrollY: 0,
//                 windowWidth: elementToCapture.scrollWidth, // Capture full width
//                 // windowHeight: elementToCapture.scrollHeight // DON'T set height here for multi-page
//             },
//             jsPDF: {
//                 unit: "px",
//                 format: [PAGE_WIDTH_PX, PAGE_HEIGHT_PX], // A4-like dimensions in pixels
//                 orientation: "portrait",
//             },
//             // Let html2pdf handle page breaks automatically based on element structure
//             // pagebreak: { mode: ['css', 'avoid-all'] } // Can experiment if needed, but default often works well with distinct page divs
//         };

//         try {
//             console.log(`Capturing element for PDF. Expected Pages: ${renderedPagesData.length}`);
//             // Add a slightly longer delay to ensure all images (signature, stamp) are loaded
//             await new Promise(resolve => setTimeout(resolve, 600));

//             const pdf = html2pdf().from(elementToCapture).set(opt);
//             const pdfBlob = await pdf.output('blob');

//             console.log("PDF Blob created, size:", pdfBlob.size);

//             if (pdfBlob.size === 0) {
//                 throw new Error("Generated PDF blob is empty.");
//             }

//             // Prepare data for backend
//             const formDataToSend = new FormData();
//             formDataToSend.append("pdf", pdfBlob, `${safeData.candidateName}_offer_letter.pdf`);
//             formDataToSend.append("candidateName", safeData.candidateName);
//             if (safeData.user_id) {
//                 formDataToSend.append("user_id", safeData.user_id);
//             }

//             console.log("Sending PDF to backend...");
//             const response = await axios.post(
//                 "https://raasbackend.vetrinahealthcare.com/save_pdf/", // Ensure URL is correct
//                 formDataToSend,
//                 { headers: { "Content-Type": "multipart/form-data" } }
//             );

//             Swal.close();
//             if (btn) btn.style.visibility = 'visible'; // Show button again
//             console.log("Backend response:", response.data);
//             Swal.fire({
//                 icon: "success",
//                 title: "Offer Letter PDF Saved!",
//                 text: response.data.message || "The generated PDF has been saved successfully.",
//                 timer: 2500,
//                 timerProgressBar: true,
//                 showConfirmButton: false,
//             }).then(() => {
//                 navigate("/letterform"); // Navigate back after success
//             });

//         } catch (error) {
//             if (btn) btn.style.visibility = 'visible'; // Show button again on error
//             Swal.close();
//             console.error("Error during PDF generation or saving:", error);
//             if (error.response) {
//                 console.error("Backend Error Response:", error.response.data);
//             } else {
//                  console.error("PDF Generation/Setup Error:", error.message);
//             }
//             const errorText = error.response?.data?.error || error.message || "An unexpected error occurred during PDF generation or saving.";
//             Swal.fire("PDF Generation Failed", `Error: ${errorText}. Please check console logs.`, "error");
//         }
//     };

//     // --- RENDER FUNCTIONS ---

//     // Header (From Modified Code - uses constants)
//     const renderHeader = () => (
//         <>
//             {/* Using constants for positioning */}
//             <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 17}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, zIndex: 2, fontSize: "10px" }}>To,</div>
//             <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 32}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, fontWeight: "bold", zIndex: 2, fontSize: "10px" }}>{safeData.candidateName},</div>
//             <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 45}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, width: `${CONTENT_WIDTH_PX}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}>Address - {safeData.address}</div>
//             <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 58}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, width: `${CONTENT_WIDTH_PX}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}>Pin code - {safeData.pinCode}</div>
//             <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 72}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, width: `${CONTENT_WIDTH_PX}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}>Mobile No.: {safeData.mobileNumber}</div>
//             <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX}px`, right: `${HEADER_CONTENT_RIGHT_MARGIN_PX}px`, width: "150px", textAlign: "right", zIndex: 2, fontSize: "10px" }}>Date - {safeData.date}</div>
//         </>
//     );

//     // Footer (From Modified Code - uses constants and signature placement)
//     const renderFooter = () => (
//         <div style={{
//             position: 'absolute',
//             top: `${FOOTER_TOP_PX}px`, // Position the whole footer block
//             left: `${FOOTER_LEFT_PX}px`,
//             width: `${FOOTER_WIDTH_PX}px`,
//             zIndex: 2 // Ensure footer text is above background
//         }}>
//             {/* Position elements *relative* to the footer block's top/left */}
//             {/* <div style={{ position: "absolute", top: `-70px`, left: `0px`, width: "100%", textAlign: "justify", fontSize: "10px" }}>If you have any question or concerns, please feel free to contact us.</div> */}
//             <div style={{ position: "absolute", top: `-30px`, left: `0px`, width: "100%", textAlign: "left", fontSize: "10px" }}>Thanks & Regards</div>

//             {/* Stamp Image */}
//             <div style={{ position: "absolute", top: `${STAMP_OFFSET_TOP_PX}px`, left: `${STAMP_OFFSET_LEFT_PX}px`, width: `${STAMP_WIDTH_PX}px`, height: `${STAMP_HEIGHT_PX}px`, zIndex: 3 /* Above text */ }}>
//                 <img src={VetrinaStamp} alt="Vetrina Stamp" style={{ maxWidth: "120%", maxHeight: "120%" }} />
//             </div>

//             {/* Signature Image */}
//             {safeData.signaturePreviewUrl && (
//                 <div style={{
//                     position: "absolute",
//                     top: `${SIGNATURE_OFFSET_TOP_PX}px`, // Relative to footer top
//                     left: `${SIGNATURE_OFFSET_LEFT_PX}px`, // Relative to footer left
//                     width: `${SIGNATURE_WIDTH_PX}px`,
//                     height: `${SIGNATURE_HEIGHT_PX}px`,
//                     zIndex: 3 /* Above text */
//                 }}>
//                     <img
//                         src={safeData.signaturePreviewUrl}
//                         alt="Signature Preview"
//                         style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
//                     />
//                 </div>
//             )}

//             {/* HR Name and Title Text */}
//             <div style={{ position: "absolute", top: `40px`, left: `0px`, width: "100%", textAlign: "left", fontSize: "10px" }}>
//                 Mr / Mrs. {safeData.hrName} <br />
//                 {safeData.hrTitle}<br />
//                 Vetrina Healthcare Pvt. Ltd.
//             </div>
//         </div>
//     );

//     // Template Content Rendering (Using Original Code's structure, adapted with constants)
//     const renderTemplateContent = () => {
//         const topBase = CONTENT_TOP_PAGE_1_PX; // Template content starts at this Y position on page 1
//         const leftPos = CONTENT_LEFT_PX;
//         const width = CONTENT_WIDTH_PX;
//         return (
//             <>
//                 {/* Content structure directly from Original Code */}
//                 <div style={{ position: "absolute", top: `${topBase}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}><u>Subject: - Offer letter for the position of {safeData.position}.</u></div>
//                 <div style={{ position: "absolute", top: `${topBase + 40}px`, left: `${leftPos}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}>Dear Mr./Ms. {safeData.candidateName.split(' ')[0]},</div>
//                 <div style={{ position: "absolute", top: `${topBase + 80}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Based on our discussion in your interview we would like to offer you the position of <strong>{safeData.position} at VETRINA HEALTHCARE PVT. LTD.</strong> You will report to <strong>{safeData.reportingTo || '[Reporting Manager Name]'}</strong> who will define your roles and responsibility.</div>
//                 <div style={{ position: "absolute", top: `${topBase + 120}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Your annual CTC will be INR <strong>{safeData.salary} /- LAKH PER ANNUM.</strong> We will increase your salary, after analyzing your performance.</div>
//                 <div style={{ position: "absolute", top: `${topBase + 160}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Initially you will be based at HQ <strong>{safeData.basedHQ || '[Base HQ Name]'}.</strong> You will be responsible for the development of company business of Vetrina Healthcare Pvt. Ltd. You are liable to be transferred from time to time to other places as may be notified to you by company.</div>
//                 <div style={{ position: "absolute", top: `${topBase + 210}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>The company might pay variable bonus and incentives. This will be dependent on your performance in company in specific time frame. The decision to grant a bonus and the manner in which it will be calculated is at the sole discretion of the company and is not negotiable.</div>
//                 <div style={{ position: "absolute", top: `${topBase + 270}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>You will be required to abide by the rules and regulations of <strong>VETRINA HEALTHCARE PVT. LTD</strong>, that may be in force at the time of your appointment and also that may be promulgated from time to time thereafter.</div>
//             </>
//         );
//     };

//     // Custom Content Rendering (From Modified Code - handles pagination)
//     const renderCustomContent = (contentChunk, pageIndex) => {
//         // Determine top margin based on page number
//         const topMargin = pageIndex === 0 ? CONTENT_TOP_PAGE_1_PX : CONTENT_TOP_SUBSEQUENT_PX;
//         const leftPos = CONTENT_LEFT_PX;
//         const width = CONTENT_WIDTH_PX;
//         // Calculate available height (mostly for reference, actual height is determined by content)
//         // const height = pageIndex === 0
//         //     ? MAX_CONTENT_FILL_HEIGHT_PAGE_1
//         //     : MAX_CONTENT_HEIGHT_SUBSEQUENT;

//         return (
//             <div style={{
//                 position: "absolute",
//                 top: `${topMargin}px`,
//                 left: `${leftPos}px`,
//                 width: `${width}px`,
//                 // height: `${height}px`, // Let content define height, don't restrict with fixed height
//                 zIndex: 2,
//                 fontSize: "10px",
//                 lineHeight: "1.4", // Match measureRef line height
//                 textAlign: "justify",
//                 whiteSpace: "pre-wrap", // Preserve line breaks from input
//                 overflowWrap: "break-word", // Break long words
//                 // overflowY: "hidden" // Ensure content doesn't spill outside calculated area
//             }}>
//                 {contentChunk}
//             </div>
//         );
//     }

//     // --- Main Render Logic ---

//     // Loading/Redirecting state before data is validated
//     if (!isDataValid && !isCalculatingPages) { // Show loading only if not validated AND not calculating
//         return (
//             <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
//                 <DashNavbar />
//                 <div style={{ display: "flex", flex: 1 }}>
//                     <Sidebar />
//                     <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
//                         <p>Validating data or redirecting...</p>
//                          {/* Optionally add a spinner here too */}
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     // Main component render
//     return (
//          <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//             <DashNavbar />
//             <div style={{ display: "flex", flexGrow: 1 }}>
//                 <Sidebar />
//                 {/* Main Content Area */}
//                 <div style={{
//                     flexGrow: 1,
//                     backgroundColor: "#e0e0e0", // Grey background for contrast
//                     padding: "30px 20px",
//                     overflowY: 'auto', // Allow scrolling the whole preview area if needed
//                     display: 'flex',
//                     flexDirection: 'column', // Stack button and letter vertically
//                     alignItems: 'center', // Center the letter preview horizontally
//                     position: 'relative' // Needed for absolute positioning of button and measure div
//                 }}>

//                     {/* Save Button (Positioned top-right relative to content area) */}
//                     <div
//                         id="save-pdf-button-container"
//                         style={{
//                             width: '100%', // Take full width of container
//                             maxWidth: `${PAGE_WIDTH_PX}px`, // Align with letter width
//                             display: 'flex',
//                             justifyContent: 'flex-end', // Push button to the right
//                             marginBottom: '20px', // Space below button
//                             paddingRight: '0px' // Align button edge with letter edge
//                          }}
//                     >
//                         <Button
//                             onClick={downloadAsPDF}
//                             variant="primary"
//                             size="lg"
//                             disabled={isCalculatingPages || renderedPagesData.length === 0} // Disable while calculating or if no pages
//                         >
//                            {isCalculatingPages ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/> : <i className="fas fa-save me-2"></i>}
//                             Save Final PDF
//                         </Button>
//                     </div>

//                     {/* Hidden Measurement Div (Crucial for custom pagination) */}
//                     <div
//                         ref={measureRef}
//                         style={{
//                             position: 'absolute',
//                             top: '-9999px', // Off-screen
//                             left: '-9999px', // Off-screen
//                             fontSize: '10px', // Must match rendered content
//                             lineHeight: '1.4', // Must match rendered content
//                             whiteSpace: 'pre-wrap', // Must match rendered content
//                             overflowWrap: 'break-word', // Must match rendered content
//                             zIndex: -1, // Behind everything
//                             fontFamily: "'Arial', sans-serif", // Match font
//                             visibility: 'hidden', // Hide visually
//                             width: `${CONTENT_WIDTH_PX}px` // Critical: Set width for height calc
//                         }}
//                     ></div>

//                     {/* Letter Preview Container */}
//                     <div style={{
//                          width: `${PAGE_WIDTH_PX}px`, // Fixed width
//                          display: 'flex',
//                          flexDirection: 'column',
//                          alignItems: 'center',
//                          boxShadow: '0 0 10px rgba(0,0,0,0.2)' // Visual separation
//                     }}>
//                         {/* Container Ref for PDF generation (Contains all pages) */}
//                         <div
//                             ref={offerLetterRef}
//                             style={{
//                                 width: `${PAGE_WIDTH_PX}px`,
//                                 margin: 0,
//                                 padding: 0,
//                                 backgroundColor: '#fff',
//                                 lineHeight: 0, // Reset line height for container
//                                 fontSize: 0, // Reset font size for container
//                                 display: 'block', // Ensure it behaves like a block
//                             }}
//                         >
//                             {/* Render Pages based on calculation */}
//                             {isCalculatingPages ? (
//                                 // Show spinner covering the first page area while calculating
//                                 <div style={{width: `${PAGE_WIDTH_PX}px`, height: `${PAGE_HEIGHT_PX}px`, display:'flex', justifyContent:'center', alignItems:'center', backgroundColor: '#fff'}}>
//                                     <Spinner animation="border" role="status">
//                                         <span className="visually-hidden">Calculating Pages...</span>
//                                     </Spinner>
//                                 </div>
//                             ) : renderedPagesData.length > 0 ? (
//                                 // Map over the calculated page data
//                                 renderedPagesData.map((pageContent, index) => (
//                                     <div
//                                         key={index}
//                                         className="offer-letter-page" // Useful for potential CSS targeting
//                                         style={{
//                                             width: `${PAGE_WIDTH_PX}px`,
//                                             height: `${PAGE_HEIGHT_PX}px`,
//                                             backgroundColor: "#ffffff", // White background for each page
//                                             position: "relative", // Needed for absolute positioning of content inside
//                                             overflow: "hidden", // Clip content that might overflow page boundaries
//                                             fontFamily: "'Arial', sans-serif", // Base font
//                                             fontSize: "10px", // Base font size
//                                             color: "black",
//                                             lineHeight: "1.3", // Base line height
//                                             boxSizing: "border-box", // Include padding/border in size
//                                             margin: 0, // No margin between pages
//                                             padding: 0, // No padding on the page div itself
//                                             display: 'block', // Ensure div takes up block space
//                                             // pageBreakAfter: 'always' // Hint for printing/PDF - handled by html2pdf structure
//                                         }}
//                                     >
//                                         {/* Background Image for EVERY page */}
//                                         <img
//                                             src={offerLetterBackgroundImage}
//                                             alt={`Background Page ${index + 1}`}
//                                             style={{
//                                                 position: 'absolute', top: 0, left: 0,
//                                                 width: '100%', height: '100%',
//                                                 objectFit: 'cover', zIndex: 1 // Behind content
//                                             }}
//                                         />

//                                         {/* Render Header ONLY on the first page (index 0) */}
//                                         {index === 0 && renderHeader()}

//                                         {/* Render Content based on Generation Method */}
//                                         {safeData.generationMethod === 'template' && index === 0 ? (
//                                             // Template content only goes on the first page
//                                             renderTemplateContent()
//                                         ) : safeData.generationMethod === 'custom' ? (
//                                             // Custom content is rendered per calculated page chunk
//                                             renderCustomContent(pageContent, index)
//                                         ) : (
//                                             // Fallback if method is somehow invalid (shouldn't happen with validation)
//                                             <p style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', zIndex:2, color:'red'}}>Invalid Generation Method</p>
//                                         )}

//                                         {/* Render Footer ONLY on the LAST page */}
//                                         {index === renderedPagesData.length - 1 && renderFooter()}

//                                     </div> // End individual page div
//                                 )) // End map loop
//                             ) : (
//                                 // Case where calculation finished but resulted in zero pages (e.g., empty custom content)
//                                 <div style={{ width: `${PAGE_WIDTH_PX}px`, height: `${PAGE_HEIGHT_PX}px`, backgroundColor: "#ffffff", position: "relative", overflow: "hidden" }}>
//                                     <img src={offerLetterBackgroundImage} alt="Background Page 1" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }} />
//                                     <p style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2, color: 'grey'}}>No content to display. Check input data.</p>
//                                 </div>
//                             )}
//                         </div> {/* End Ref Container (offerLetterRef) */}
//                     </div> {/* End Letter Preview Container */}
//                 </div> {/* End Main Content Area */}
//             </div> {/* End flex row (Sidebar + Content) */}
//         </div> /* End outer container */
//     );
// };

// export default OfferLetter;



// // OfferLetter.js
// import React, { useRef, useEffect, useState, useMemo } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { Button, Spinner } from "react-bootstrap";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import { useLocation, useNavigate } from "react-router-dom";
// import offerLetterBackgroundImage from "../../Assets/Vetrina Offer Letter-1.png";
// import html2pdf from "html2pdf.js";
// import axios from "axios";
// import Swal from "sweetalert2";
// import VetrinaStamp from "../../Assets/VetrinaStamp.png";

// // =====================================================================
// // ===== MANUAL LAYOUT CONFIGURATION (Keep As Is) ======================
// // =====================================================================
// const PAGE_WIDTH_PX = 595;
// const PAGE_HEIGHT_PX = 842;
// const HEADER_CONTENT_LEFT_PX = 68;
// const HEADER_CONTENT_RIGHT_MARGIN_PX = 60;
// const HEADER_CONTENT_TOP_PX = 83;
// const CONTENT_LEFT_PX = 68;
// const CONTENT_WIDTH_PX = 475;
// const CONTENT_TOP_PAGE_1_PX = 200;
// const CONTENT_TOP_SUBSEQUENT_PX = 70;
// const CONTENT_BOTTOM_MARGIN_PX = 55;
// const FOOTER_TOP_PX = 640;
// const FOOTER_LEFT_PX = 68;
// const FOOTER_WIDTH_PX = 475;
// const STAMP_OFFSET_TOP_PX = -50;
// const STAMP_OFFSET_LEFT_PX = 72;
// const STAMP_WIDTH_PX = 100;
// const STAMP_HEIGHT_PX = 100;
// const SIGNATURE_OFFSET_TOP_PX = -10;
// const SIGNATURE_OFFSET_LEFT_PX = 0;
// const SIGNATURE_WIDTH_PX = 100;
// const SIGNATURE_HEIGHT_PX = 50;
// // =====================================================================
// // ===== DERIVED CALCULATIONS (Keep As Is) =============================
// // =====================================================================
// const MAX_CONTENT_FILL_HEIGHT_PAGE_1 = PAGE_HEIGHT_PX - CONTENT_TOP_PAGE_1_PX - CONTENT_BOTTOM_MARGIN_PX;
// const MAX_CONTENT_HEIGHT_SUBSEQUENT = FOOTER_TOP_PX - CONTENT_TOP_SUBSEQUENT_PX - 15;
// // =====================================================================

// // --- Helper Functions ---
// const formatDate = (date) => { /* ... (keep) ... */
//     if (!date) return ""; try { if (typeof date === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(date)) { return date; } const d = new Date(date); if (isNaN(d.getTime())) { const isoDate = new Date(Date.parse(date)); if (isNaN(isoDate.getTime())) { console.warn("Invalid date:", date); return "Invalid Date"; } const day = String(isoDate.getDate()).padStart(2, "0"); const month = String(isoDate.getMonth() + 1).padStart(2, "0"); const year = isoDate.getFullYear(); return `${day}/${month}/${year}`; } const day = String(d.getDate()).padStart(2, "0"); const month = String(d.getMonth() + 1).padStart(2, "0"); const year = d.getFullYear(); return `${day}/${month}/${year}`; } catch (e) { console.error("Date format error:", date, e); return "Error Date"; }
// };


// const OfferLetter = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const formData = location.state || {};
//     const offerLetterRef = useRef(null);
//     const measureRef = useRef(null);

//     const [renderedPagesData, setRenderedPagesData] = useState([]);
//     const [isCalculatingPages, setIsCalculatingPages] = useState(false);
//     const [isDataValid, setIsDataValid] = useState(false);

//     const safeData = useMemo(() => ({ /* ... (keep safeData memoization) ... */
//         candidateName: formData.candidateName || "Candidate Name", date: formatDate(formData.date), address: formData.address || "[Address]", pinCode: formData.pinCode || "[Pin Code]", mobileNumber: formData.mobileNumber || "[Mobile Number]", hrName: formData.hr?.name || "[HR Manager Name]", hrTitle: "HR Manager", position: formData.position || "[Position]", salary: formData.salary || "[N/A]", reportingTo: formData.reporting_manager || "[Reporting Manager]", basedHQ: formData.headquarter || "[Base HQ]", customContent: formData.customContent || "", generationMethod: formData.generationMethod, signaturePreviewUrl: formData.signaturePreviewUrl || null, user_id: formData.user_id,
//     }), [formData]);

//     // *** UPDATED Validation Effect ***
//     useEffect(() => {
//         console.log("OfferLetter State:", formData);
//         let isDataMissing = false;
//         let missingFields = [];

//         // Basic checks
//         if (!safeData.candidateName || safeData.candidateName === "Candidate Name") { isDataMissing = true; missingFields.push('candidateName'); }
//         if (!safeData.date || safeData.date === "Invalid Date" || safeData.date === "Error Date") { isDataMissing = true; missingFields.push('date'); }
//         if (!safeData.hrName || safeData.hrName === "[HR Manager Name]") { isDataMissing = true; missingFields.push('hr'); }

//         // Template specific checks
//         if (safeData.generationMethod === 'template') {
//             const flds = ['position', 'salary', 'address', 'pinCode', 'mobileNumber'];
//             flds.forEach(f => {
//                 const value = safeData[f]; // Get the value
//                 // Check if value is missing OR (if it's a string AND starts with '[')
//                 if (!value || (typeof value === 'string' && value.startsWith('['))) {
//                      isDataMissing = true;
//                      if (!missingFields.includes(f)) missingFields.push(f);
//                 }
//             });
//         }
//         // Custom specific checks
//         else if (safeData.generationMethod === 'custom') {
//              if (!safeData.customContent) {
//                  isDataMissing = true;
//                  if (!missingFields.includes('customContent')) missingFields.push('customContent');
//              }
//         }
//         // Check if generationMethod itself is missing/invalid
//         else {
//             isDataMissing = true;
//             missingFields.push('generationMethod');
//         }

//         // Check section type
//         const isIncorrectSection = formData.section !== 'Offer Letter';
//         if (isIncorrectSection) {
//              // This condition might not be strictly necessary if the component is only
//              // routed to for Offer Letters, but good for robustness.
//              // We'll keep the console error but might not need to block based on it
//              // unless it's a critical requirement.
//              console.error("Incorrect section type detected:", formData.section);
//              // Optionally add: isDataMissing = true; if (!missingFields.includes('section')) missingFields.push('section');
//         }

//         // Final check and action
//         if (isDataMissing) { // Simplified check: any missing data is an issue
//             setIsDataValid(false);
//             console.error("Invalid Data:", { safeData, missingFields, isIncorrectSection });
//             // Show error only if critical data is missing
//             if (missingFields.length > 0) {
//                 Swal.fire({
//                     icon: "error",
//                     title: "Invalid Data",
//                     text: `Missing required fields (${missingFields.join(', ')}). Redirecting.`,
//                     confirmButtonText: "OK"
//                 }).then(() => { navigate("/letterform"); });
//             }
//         } else {
//             setIsDataValid(true); // All checks passed
//         }
//     }, [safeData, formData.section, navigate]); // Keep dependencies

//     // --- Page Calculation Effect (Keep Strict Filtering) ---
//     useEffect(() => {
//         if (!isDataValid || !measureRef.current) return;

//         if (safeData.generationMethod === 'custom' && safeData.customContent) {
//             setIsCalculatingPages(true);
//             setTimeout(() => {
//                 if (!measureRef.current) { console.error("Measure ref gone."); setIsCalculatingPages(false); return; }

//                 const calculatedPages = [];
//                 const contentLines = safeData.customContent.split('\n');
//                 let currentPageContent = "";
//                 const measureDiv = measureRef.current;
//                 measureDiv.style.width = `${CONTENT_WIDTH_PX}px`;
//                 measureDiv.innerHTML = '';

//                 contentLines.forEach((line, index) => {
//                     const contentWithNewLine = currentPageContent + (currentPageContent ? '\n' : '') + line;
//                     measureDiv.innerText = contentWithNewLine;
//                     const estimatedHeight = measureDiv.scrollHeight;
//                     const isFirstPage = calculatedPages.length === 0;
//                     const maxHeightForThisPage = isFirstPage ? MAX_CONTENT_FILL_HEIGHT_PAGE_1 : MAX_CONTENT_HEIGHT_SUBSEQUENT;

//                     if (estimatedHeight > maxHeightForThisPage && currentPageContent.trim()) {
//                         calculatedPages.push(currentPageContent);
//                         currentPageContent = line;
//                         measureDiv.innerText = line;
//                     } else {
//                          currentPageContent += (currentPageContent ? '\n' : '') + line;
//                     }
//                 });

//                 if (currentPageContent.trim()) {
//                     calculatedPages.push(currentPageContent);
//                 }
//                 setRenderedPagesData(calculatedPages); // Set the filtered pages directly
//                 setIsCalculatingPages(false);
//                 console.log(`Calculation resulted in ${calculatedPages.length} non-empty pages.`);

//             }, 100);
//         } else if (safeData.generationMethod === 'template') {
//              setRenderedPagesData(['template_content']);
//              setIsCalculatingPages(false);
//              console.log("Using single page for template.");
//         } else {
//              setRenderedPagesData(['']);
//              setIsCalculatingPages(false);
//         }
//     }, [isDataValid, safeData.generationMethod, safeData.customContent]); // Keep Dependencies

//     const downloadAsPDF = async () => { // Keep as is from previous version
//         if (!offerLetterRef.current || !isDataValid || renderedPagesData.length === 0) {
//             Swal.fire("Error", "Cannot generate PDF. No content pages or invalid data.", "error");
//             return;
//         }
//         const elementToCapture = offerLetterRef.current;
//         if (!safeData.candidateName || safeData.candidateName === "Candidate Name") { Swal.fire("Error", "Cannot generate PDF. Missing name.", "error"); return; }
//         const btn = document.getElementById('save-pdf-button-container'); if (btn) btn.style.visibility = 'hidden';
//         Swal.fire({ title: 'Generating PDF...', text: 'Please wait...', allowOutsideClick: false, didOpen: () => { Swal.showLoading(); } });

//         const opt = {
//             margin: 0,
//             filename: `${safeData.candidateName}_offer_letter.pdf`,
//             image: { type: "jpeg", quality: 0.98 },
//             html2canvas: {
//                 scale: 2,
//                 useCORS: true,
//                 logging: false,
//                 scrollX: 0,
//                 scrollY: 0,
//                 windowWidth: elementToCapture.scrollWidth,
//             },
//             jsPDF: {
//                 unit: "px",
//                 format: [PAGE_WIDTH_PX, PAGE_HEIGHT_PX],
//                 orientation: "portrait",
//             },
//             // NO explicit pagebreak option
//         };

//         try {
//             console.log("Capturing element for PDF. Rendering Pages:", renderedPagesData.length);
//             await new Promise(resolve => setTimeout(resolve, 600));
//             const pdf = html2pdf().from(elementToCapture).set(opt);
//             const pdfBlob = await pdf.output('blob');
//             console.log("PDF Blob size:", pdfBlob.size);
//             const formDataToSend = new FormData(); formDataToSend.append("pdf", pdfBlob, `${safeData.candidateName}_offer_letter.pdf`); formDataToSend.append("candidateName", safeData.candidateName); if (safeData.user_id) { formDataToSend.append("user_id", safeData.user_id); } console.log("Sending PDF..."); const response = await axios.post("https://raasbackend.vetrinahealthcare.com/save_pdf/", formDataToSend, { headers: { "Content-Type": "multipart/form-data" } }); Swal.close(); if (btn) btn.style.visibility = 'visible'; console.log("Backend response:", response.data); Swal.fire({ icon: "success", title: "PDF Saved!", text: response.data.message || "Saved.", timer: 2500, timerProgressBar: true, showConfirmButton: false, }).then(() => { navigate("/letterform"); });
//         } catch (error) { if (btn) btn.style.visibility = 'visible'; Swal.close(); console.error("PDF Generation Error:", error); const errorText = error.response?.data?.error || error.message || "Unexpected error during PDF generation."; Swal.fire("PDF Failed", `Error: ${errorText}. Check console.`, "error"); }
//     };

//     // --- RENDER FUNCTIONS (Keep As Is) ---
//     const renderHeader = () => ( /* ... (keep) ... */ <> <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 17}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, zIndex: 2, fontSize: "10px" }}>To,</div> <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 32}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, fontWeight: "bold", zIndex: 2, fontSize: "10px" }}>{safeData.candidateName},</div> <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 45}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, width: `${CONTENT_WIDTH_PX}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}>Address - {safeData.address}</div> <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 58}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, width: `${CONTENT_WIDTH_PX}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}>Pin code - {safeData.pinCode}</div> <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX + 72}px`, left: `${HEADER_CONTENT_LEFT_PX}px`, width: `${CONTENT_WIDTH_PX}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}>Mobile No.: {safeData.mobileNumber}</div> <div style={{ position: "absolute", top: `${HEADER_CONTENT_TOP_PX}px`, right: `${HEADER_CONTENT_RIGHT_MARGIN_PX}px`, width: "150px", textAlign: "right", zIndex: 2, fontSize: "10px" }}>Date - {safeData.date}</div> </> );
//     const renderFooter = () => ( /* ... (keep) ... */ <div style={{position: 'absolute', top: `${FOOTER_TOP_PX}px`, left: `${FOOTER_LEFT_PX}px`, width: `${FOOTER_WIDTH_PX}px`, zIndex: 2}}> <div style={{ position: "absolute", top: `-70px`, left: `0px`, width: "100%", textAlign: "justify", fontSize: "10px" }}>If you have any question or concerns, please feel free to contact us.</div> <div style={{ position: "absolute", top: `-30px`, left: `0px`, width: "100%", textAlign: "left", fontSize: "10px" }}>Thanks & Regards</div> <div style={{ position: "absolute", top: `${STAMP_OFFSET_TOP_PX}px`, left: `${STAMP_OFFSET_LEFT_PX}px`, width: `${STAMP_WIDTH_PX}px`, height: `${STAMP_HEIGHT_PX}px`, zIndex: 3 }}> <img src={VetrinaStamp} alt="Vetrina Stamp" style={{ maxWidth: "120%", maxHeight: "120%" }} /> </div> {safeData.signaturePreviewUrl && ( <div style={{ position: "absolute", top: `${SIGNATURE_OFFSET_TOP_PX}px`, left: `${SIGNATURE_OFFSET_LEFT_PX}px`, width: `${SIGNATURE_WIDTH_PX}px`, height: `${SIGNATURE_HEIGHT_PX}px`, zIndex: 3 }}> <img src={safeData.signaturePreviewUrl} alt="Signature Preview" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} /> </div> )} <div style={{ position: "absolute", top: `40px`, left: `0px`, width: "100%", textAlign: "left", fontSize: "10px" }}> Mr / Mrs. {safeData.hrName} <br /> {safeData.hrTitle}<br /> Vetrina Healthcare Pvt. Ltd. </div> </div> );
//     const renderTemplateContent = () => { /* ... (keep) ... */ const topBase = CONTENT_TOP_PAGE_1_PX; const leftPos = CONTENT_LEFT_PX; const width = CONTENT_WIDTH_PX; return <> <div style={{ position: "absolute", top: `${topBase}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}><u>Subject: - Offer letter... {safeData.position}.</u></div> <div style={{ position: "absolute", top: `${topBase + 40}px`, left: `${leftPos}px`, textAlign: "left", zIndex: 2, fontSize: "10px" }}>Dear Mr./Ms. {safeData.candidateName.split(' ')[0]},</div> <div style={{ position: "absolute", top: `${topBase + 80}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Based on our discussion... <strong>{safeData.position}...</strong>...<strong>{safeData.reportingTo || '[Reporting Manager]'}</strong>...</div> <div style={{ position: "absolute", top: `${topBase + 120}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Your annual CTC... <strong>{safeData.salary}...</strong>...</div> <div style={{ position: "absolute", top: `${topBase + 160}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>Initially... HQ <strong>{safeData.basedHQ || '[Base HQ]'}</strong>...</div> <div style={{ position: "absolute", top: `${topBase + 210}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>The company might pay variable bonus...</div> <div style={{ position: "absolute", top: `${topBase + 270}px`, left: `${leftPos}px`, width: `${width}px`, textAlign: "justify", zIndex: 2, fontSize: "10px" }}>You will be required to abide...</div> </>; };
//     const renderCustomContent = (contentChunk, pageIndex) => { /* ... (keep - no explicit height) ... */ const topMargin = pageIndex === 0 ? CONTENT_TOP_PAGE_1_PX : CONTENT_TOP_SUBSEQUENT_PX; const leftPos = CONTENT_LEFT_PX; const width = CONTENT_WIDTH_PX; return ( <div style={{ position: "absolute", top: `${topMargin}px`, left: `${leftPos}px`, width: `${width}px`, zIndex: 2, fontSize: "10px", lineHeight: "1.4", textAlign: "justify", whiteSpace: "pre-wrap", overflowWrap: "break-word", }}> {contentChunk} </div> ); }

//     // --- Main Render Logic (Keep As Is) ---
//     if (!isDataValid) { return ( /* ... Loading ... */ <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}> <DashNavbar /> <div style={{ display: "flex", flex: 1 }}> <Sidebar /> <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}> <p>Loading/Redirecting...</p> </div> </div> </div> ); }

//     return (
//          <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//             <DashNavbar />
//             <div style={{ display: "flex", flexGrow: 1 }}>
//                 <Sidebar />
//                 {/* Main Content Area */}
//                 <div style={{ flexGrow: 1, backgroundColor: "#e0e0e0", padding: "30px 20px", overflowY: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>

//                     {/* Save Button */}
//                     <div id="save-pdf-button-container" style={{ width: '100%', maxWidth: `${PAGE_WIDTH_PX}px`, display: 'flex', justifyContent: 'flex-end', marginBottom: '20px', paddingRight: '0px' }} >
//                         <Button onClick={downloadAsPDF} variant="primary" size="lg" disabled={isCalculatingPages}>
//                            {isCalculatingPages ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/> : <i className="fas fa-save me-2"></i>}
//                             Save Final PDF
//                         </Button>
//                     </div>

//                     {/* Hidden Measurement Div */}
//                     <div ref={measureRef} style={{ position: 'absolute', top: '-9999px', left: '-9999px', fontSize: '10px', lineHeight: '1.4', whiteSpace: 'pre-wrap', overflowWrap: 'break-word', zIndex: -1, fontFamily: "'Arial', sans-serif", visibility: 'hidden', }} ></div>

//                     {/* Letter Preview Container */}
//                     <div style={{ width: `${PAGE_WIDTH_PX}px`, display: 'flex', flexDirection: 'column', alignItems: 'center', boxShadow: '0 0 10px rgba(0,0,0,0.2)' }}>
//                         {/* Container Ref for PDF */}
//                         <div ref={offerLetterRef} style={{ width: `${PAGE_WIDTH_PX}px`, margin: 0, padding: 0, backgroundColor: '#fff', lineHeight: 0, fontSize: 0, display: 'block', }} >

//                             {/* Render Pages using the actual calculated content pages */}
//                             {isCalculatingPages ? (
//                                 <div style={{height: `${PAGE_HEIGHT_PX}px`, display:'flex', justifyContent:'center', alignItems:'center'}}> <Spinner animation="border"><span className="visually-hidden">Calculating...</span></Spinner> </div>
//                             ) : renderedPagesData.length > 0 ? (
//                                 renderedPagesData.map((pageContent, index) => (
//                                     <div
//                                         key={index}
//                                         className="offer-letter-page"
//                                         style={{
//                                             width: `${PAGE_WIDTH_PX}px`, height: `${PAGE_HEIGHT_PX}px`, backgroundColor: "#ffffff", position: "relative", overflow: "hidden", fontFamily: "'Arial', sans-serif", fontSize: "10px", color: "black", lineHeight: "1.3", boxSizing: "border-box", margin: 0, padding: 0, display: 'block',
//                                         }}
//                                     >
//                                         <img src={offerLetterBackgroundImage} alt={`Background Page ${index + 1}`} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }} />
//                                         {index === 0 && renderHeader()}
//                                         {safeData.generationMethod === 'template' && index === 0 ? ( renderTemplateContent() )
//                                         : safeData.generationMethod === 'custom' ? ( renderCustomContent(pageContent, index) )
//                                         : null }
//                                         {index === renderedPagesData.length - 1 && renderFooter()}
//                                     </div>
//                                 ))
//                             ) : (
//                                 <div style={{ width: `${PAGE_WIDTH_PX}px`, height: `${PAGE_HEIGHT_PX}px`, backgroundColor: "#ffffff", position: "relative", overflow: "hidden" }}>
//                                     <img src={offerLetterBackgroundImage} alt="Background Page 1" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }} />
//                                     <p style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2, color: 'grey'}}>No content to display.</p>
//                                 </div>
//                             )}
//                         </div> {/* End Ref Container */}
//                     </div> {/* End Letter Preview Container */}
//                 </div> {/* End Main Content Area */}
//             </div> {/* End flex row */}
//         </div> /* End outer container */
//     );
// };

// export default OfferLetter;